var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _polygon, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeroParking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Cloud--inject-64",
    d: "M172,53.53l-5.89,3.4a6.81,6.81,0,0,0,0-.78V54.44c0-3-2.13-4.27-4.77-2.75a9.41,9.41,0,0,0-2.84,2.73c-.43-3.82-3.43-5.24-7.07-3.14a15.74,15.74,0,0,0-7.13,12.35v2.55a6.66,6.66,0,0,0,.61,3L140,72a5.83,5.83,0,0,0-2.64,4.58c0,1.69,1.18,2.37,2.64,1.53L172,59.63a5.84,5.84,0,0,0,2.65-4.58C174.62,53.37,173.43,52.69,172,53.53Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--cloud--inject-64",
    d: "M209.91,50l-4.32,2.49a5.44,5.44,0,0,0,0-.57V50.66c0-2.23-1.56-3.13-3.49-2a6.8,6.8,0,0,0-2.08,2c-.32-2.8-2.52-3.84-5.19-2.3a11.55,11.55,0,0,0-5.22,9v1.87a5,5,0,0,0,.44,2.17l-3.59,2.08a4.27,4.27,0,0,0-1.94,3.35c0,1.24.87,1.74,1.94,1.12l23.42-13.52a4.28,4.28,0,0,0,1.93-3.36C211.84,49.87,211,49.37,209.91,50Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sun--inject-64"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "freepik--sun--inject-64",
    cx: 415.7,
    cy: 68.87,
    r: 13.03,
    style: {
      fill: "#ffbda7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Trees--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--trees--inject-64"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "461.05 276.14 225.45 140.11 225.45 162.9 461.05 298.93 461.05 276.14",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "461.05 276.14 225.45 140.11 225.45 162.9 461.05 298.93 461.05 276.14",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "461.05 307.03 489.13 290.82 489.13 259.92 461.05 276.14 461.05 307.03",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "461.05 307.03 489.13 290.82 489.13 259.92 461.05 276.14 461.05 307.03",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.53,123.9l-28.08,16.21,235.6,136,28.08-16.21Zm-21.07,16.21L253.53,128l228.57,132-21.05,12.16Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.53,123.9l-28.08,16.21,235.6,136,28.08-16.21Zm-21.07,16.21L253.53,128l228.57,132-21.05,12.16Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "253.53 127.95 253.53 144.16 468.06 268.03 482.11 259.92 253.53 127.95",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "253.53 127.95 253.53 144.16 468.06 268.03 482.11 259.92 253.53 127.95",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "253.53 127.95 232.46 140.11 246.51 148.22 253.53 144.16 253.53 127.95",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "253.53 127.95 232.46 140.11 246.51 148.22 253.53 144.16 253.53 127.95",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "253.53 127.95 232.46 140.11 246.51 148.22 253.53 144.16 253.53 127.95",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "461.05 272.08 468.06 268.03 253.53 144.16 246.51 148.22 461.05 272.08",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tree--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--tree--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M430.63,201.63a5.75,5.75,0,0,1,3.12.56,31.6,31.6,0,0,1,5.1,3.61,10.29,10.29,0,0,0,5.65,2.44c2.09.07,4.34-1.23,4.72-3.28a3,3,0,0,1,.26-1,1.52,1.52,0,0,1,1.78-.46,9.23,9.23,0,0,1,1.72,1c2.11,1.24,4.75,1,7.18.61,2-.29,4.56-1.19,4.55-3.22,0-1.33-1.16-2.31-2.08-3.28s-1.66-2.51-.82-3.54a2.41,2.41,0,0,1,1.17-.72c2.52-.82,5.6.27,7.73-1.31a4.45,4.45,0,0,0,1.12-5.33,6.78,6.78,0,0,0-4.54-3.46c-1.69-.43-3.85-.63-4.48-2.26-.55-1.43.56-3,1.82-3.85s2.76-1.49,3.63-2.75a4.33,4.33,0,0,0,.12-4.51,5.49,5.49,0,0,0-3.8-2.61,8.16,8.16,0,0,1-2.3-.51,1.52,1.52,0,0,1-.85-1.94c.22-.41.71-.63,1-1a1.82,1.82,0,0,0-.68-2.39,9.2,9.2,0,0,0-2.57-1c-1.83-.61-3.61-2.38-3.06-4.23s3.19-2.55,4-4.4c.69-1.64-.41-3.54-1.87-4.54s-3.25-1.41-4.86-2.17-3.16-2.1-3.29-3.87,1.23-3.34,2.34-4.78,2.05-3.46,1.08-5-3-1.56-4.67-2.09a7.63,7.63,0,0,1-4.59-4.15c-.44-1-.66-2.14-1.19-3.12-1.65-3.06-5.81-4.39-9-4a3.67,3.67,0,0,0-3.07,2.08,5,5,0,0,0-1.13,2.12c-.24,1.47.54,3.35-.85,4.47-2.11,1.71-5.35-.59-5.24,3.24a16.35,16.35,0,0,0,.72,4.76c.57,1.61,1.73,2.3.77,4.1-1.24,2.34-2.06,2.32-4.55,2.32-1.8,0-3.3-.1-4.62,1.26-2.33,2.41-.94,4.58,1.12,6.43,2.34,2.11,1.1,3,.79,5.76-.14,1.31.16,1.71-1,2.59-2.22,1.64-3.46,1.09-2.83,4.31.57,2.95-.31,1.94-2.86,3-2.27,1-3.76,3.41-5.6,4.93-1.18,1-3,1.74-3.09,3.45-.21,3.29,3.88,2.57,5.82,3.35,3.17,1.29,2.23,5.45-.25,7s-6.45,2.26-6.66,6c-.16,2.88,1.48,3.52,3.72,4.49,1.78.77,1.56,1,1.56,3.12,0,4.31,1.44,5.53,5.68,4.83,1.17-.2,2.94-.69,4.1-.34,1.62.49,1.07.89,1.12,2.24.11,3.48,4.16,2.5,5.87,1C425.47,203.88,428,201.89,430.63,201.63Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.63,201.63a5.75,5.75,0,0,1,3.12.56,31.6,31.6,0,0,1,5.1,3.61,10.29,10.29,0,0,0,5.65,2.44c2.09.07,4.34-1.23,4.72-3.28a3,3,0,0,1,.26-1,1.52,1.52,0,0,1,1.78-.46,9.23,9.23,0,0,1,1.72,1c2.11,1.24,4.75,1,7.18.61,2-.29,4.56-1.19,4.55-3.22,0-1.33-1.16-2.31-2.08-3.28s-1.66-2.51-.82-3.54a2.41,2.41,0,0,1,1.17-.72c2.52-.82,5.6.27,7.73-1.31a4.45,4.45,0,0,0,1.12-5.33,6.78,6.78,0,0,0-4.54-3.46c-1.69-.43-3.85-.63-4.48-2.26-.55-1.43.56-3,1.82-3.85s2.76-1.49,3.63-2.75a4.33,4.33,0,0,0,.12-4.51,5.49,5.49,0,0,0-3.8-2.61,8.16,8.16,0,0,1-2.3-.51,1.52,1.52,0,0,1-.85-1.94c.22-.41.71-.63,1-1a1.82,1.82,0,0,0-.68-2.39,9.2,9.2,0,0,0-2.57-1c-1.83-.61-3.61-2.38-3.06-4.23s3.19-2.55,4-4.4c.69-1.64-.41-3.54-1.87-4.54s-3.25-1.41-4.86-2.17-3.16-2.1-3.29-3.87,1.23-3.34,2.34-4.78,2.05-3.46,1.08-5-3-1.56-4.67-2.09a7.63,7.63,0,0,1-4.59-4.15c-.44-1-.66-2.14-1.19-3.12-1.65-3.06-5.81-4.39-9-4a3.67,3.67,0,0,0-3.07,2.08,5,5,0,0,0-1.13,2.12c-.24,1.47.54,3.35-.85,4.47-2.11,1.71-5.35-.59-5.24,3.24a16.35,16.35,0,0,0,.72,4.76c.57,1.61,1.73,2.3.77,4.1-1.24,2.34-2.06,2.32-4.55,2.32-1.8,0-3.3-.1-4.62,1.26-2.33,2.41-.94,4.58,1.12,6.43,2.34,2.11,1.1,3,.79,5.76-.14,1.31.16,1.71-1,2.59-2.22,1.64-3.46,1.09-2.83,4.31.57,2.95-.31,1.94-2.86,3-2.27,1-3.76,3.41-5.6,4.93-1.18,1-3,1.74-3.09,3.45-.21,3.29,3.88,2.57,5.82,3.35,3.17,1.29,2.23,5.45-.25,7s-6.45,2.26-6.66,6c-.16,2.88,1.48,3.52,3.72,4.49,1.78.77,1.56,1,1.56,3.12,0,4.31,1.44,5.53,5.68,4.83,1.17-.2,2.94-.69,4.1-.34,1.62.49,1.07.89,1.12,2.24.11,3.48,4.16,2.5,5.87,1C425.47,203.88,428,201.89,430.63,201.63Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463,194.3c1.93-.63,4.2-.14,6.11-.58a23.07,23.07,0,0,0-3.43-.55,9.72,9.72,0,0,0-4.85,1.06,4.49,4.49,0,0,0-1.72,1.15,2.12,2.12,0,0,0,.07,2.15c.32.76.82,1.94,0,2.57s-2.36.47-3.32.13a31.49,31.49,0,0,1-3.48-1.63,16.63,16.63,0,0,0-3.44-1.42c-.86-.21-2.37-.32-2.91.61a3.91,3.91,0,0,0-.58,1.87,3.94,3.94,0,0,1,0,1.49,2.91,2.91,0,0,1-2.05,2.18,3.68,3.68,0,0,1-3.5-1.68c-.82-1.09-1.33-2.39-2.16-3.48a7.37,7.37,0,0,0-9.77-1.42c-1.24.9-2.8,2.26-4,1.36s-.52-3.58-2-4.31c-1-.49-2.35.29-3.16-.44a2.13,2.13,0,0,1-.56-1.2c-.59-2.45-1.09-5.29.45-7.28,1.38-1.78,4.29-2.87,4-5.1-.27-1.9-2.69-2.47-4.59-2.7s-4.33-1.12-4.23-3,2.64-2.79,3-4.63c.16-.79-.11-1.67.25-2.39.55-1.08,2.1-1.13,3-1.93,1.63-1.44.36-4.14.82-6.27.33-1.51,1.55-2.69,1.95-4.18.81-3-1.89-5.8-4.72-7a16.83,16.83,0,0,1-3.22-1.49.39.39,0,0,1-.1-.08,5.85,5.85,0,0,0,2.32,3.72c2.34,2.11,1.1,3,.79,5.76-.14,1.31.16,1.71-1,2.59-2.22,1.64-3.46,1.09-2.83,4.31.57,2.95-.31,1.94-2.86,3-2.27,1-3.76,3.41-5.6,4.93-1.18,1-3,1.74-3.09,3.45-.21,3.29,3.88,2.57,5.82,3.35,3.17,1.29,2.23,5.45-.25,7s-6.45,2.26-6.66,6c-.16,2.88,1.48,3.52,3.72,4.49,1.78.77,1.56,1,1.56,3.12,0,4.31,1.44,5.53,5.68,4.83,1.17-.2,2.94-.69,4.1-.34,1.62.49,1.07.89,1.11,2.24.12,3.48,4.17,2.5,5.88,1,2-1.71,4.45-3.7,7.13-4a5.75,5.75,0,0,1,3.12.56,31.6,31.6,0,0,1,5.1,3.61,10.29,10.29,0,0,0,5.65,2.44c2.09.07,4.34-1.23,4.72-3.28a3,3,0,0,1,.26-1,1.52,1.52,0,0,1,1.78-.46,9.23,9.23,0,0,1,1.72,1c2.11,1.24,4.75,1,7.18.61,2-.29,4.56-1.19,4.55-3.22,0-1.33-1.16-2.31-2.08-3.28s-1.66-2.51-.82-3.54A2.41,2.41,0,0,1,463,194.3Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.26,161.54l13.07,25.91V175.52l1.33-31,1.93,31v8L453,158.44l-14.36,30.82V254.4a.83.83,0,0,1-.48.67,2.52,2.52,0,0,1-2.3,0,.83.83,0,0,1-.48-.67V194.05Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tree--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--tree--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.45,157.07a5.75,5.75,0,0,1,3.12.56,31.6,31.6,0,0,1,5.1,3.61,10.29,10.29,0,0,0,5.66,2.44c2.08.07,4.33-1.23,4.71-3.28a3.06,3.06,0,0,1,.26-1,1.52,1.52,0,0,1,1.78-.46,9.23,9.23,0,0,1,1.72,1c2.11,1.24,4.75,1,7.18.61,2-.29,4.56-1.19,4.55-3.22,0-1.33-1.16-2.31-2.08-3.28s-1.66-2.51-.82-3.54a2.41,2.41,0,0,1,1.17-.72c2.52-.82,5.6.27,7.73-1.31a4.45,4.45,0,0,0,1.12-5.33,6.78,6.78,0,0,0-4.54-3.46c-1.69-.43-3.84-.63-4.47-2.26-.56-1.43.55-3,1.81-3.85s2.76-1.49,3.63-2.75a4.33,4.33,0,0,0,.12-4.51,5.47,5.47,0,0,0-3.79-2.61,8.16,8.16,0,0,1-2.31-.51,1.53,1.53,0,0,1-.85-1.94c.23-.41.71-.63,1-1a1.83,1.83,0,0,0-.68-2.4,9.2,9.2,0,0,0-2.57-1c-1.83-.61-3.6-2.38-3.06-4.23s3.19-2.55,4-4.4c.69-1.63-.41-3.54-1.87-4.54s-3.25-1.41-4.86-2.17-3.16-2.1-3.29-3.87,1.23-3.34,2.34-4.78,2.05-3.46,1.08-5-3-1.56-4.67-2.09A7.63,7.63,0,0,1,367,81.58c-.44-1-.66-2.14-1.19-3.12-1.65-3.06-5.81-4.39-9-4a3.67,3.67,0,0,0-3.07,2.08,4.86,4.86,0,0,0-1.12,2.12c-.25,1.47.53,3.35-.86,4.47-2.11,1.71-5.35-.59-5.24,3.24a16.35,16.35,0,0,0,.72,4.76c.57,1.61,1.73,2.3.77,4.1-1.24,2.34-2.06,2.32-4.54,2.32-1.81,0-3.31-.1-4.63,1.27-2.32,2.4-.94,4.57,1.12,6.42,2.34,2.11,1.1,3,.8,5.76-.15,1.31.15,1.71-1,2.59-2.22,1.64-3.46,1.09-2.83,4.32.57,2.94-.31,1.93-2.86,3-2.27,1-3.76,3.41-5.6,4.93-1.17,1-3,1.74-3.08,3.45-.22,3.29,3.87,2.57,5.81,3.35,3.17,1.29,2.23,5.45-.25,7s-6.45,2.26-6.66,6c-.16,2.88,1.48,3.52,3.72,4.49,1.79.77,1.56,1,1.56,3.13,0,4.3,1.44,5.52,5.68,4.82,1.17-.2,2.94-.69,4.1-.34,1.62.49,1.07.89,1.12,2.24.11,3.48,4.16,2.5,5.87,1C348.29,159.32,350.77,157.33,353.45,157.07Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.45,157.07a5.75,5.75,0,0,1,3.12.56,31.6,31.6,0,0,1,5.1,3.61,10.29,10.29,0,0,0,5.66,2.44c2.08.07,4.33-1.23,4.71-3.28a3.06,3.06,0,0,1,.26-1,1.52,1.52,0,0,1,1.78-.46,9.23,9.23,0,0,1,1.72,1c2.11,1.24,4.75,1,7.18.61,2-.29,4.56-1.19,4.55-3.22,0-1.33-1.16-2.31-2.08-3.28s-1.66-2.51-.82-3.54a2.41,2.41,0,0,1,1.17-.72c2.52-.82,5.6.27,7.73-1.31a4.45,4.45,0,0,0,1.12-5.33,6.78,6.78,0,0,0-4.54-3.46c-1.69-.43-3.84-.63-4.47-2.26-.56-1.43.55-3,1.81-3.85s2.76-1.49,3.63-2.75a4.33,4.33,0,0,0,.12-4.51,5.47,5.47,0,0,0-3.79-2.61,8.16,8.16,0,0,1-2.31-.51,1.53,1.53,0,0,1-.85-1.94c.23-.41.71-.63,1-1a1.83,1.83,0,0,0-.68-2.4,9.2,9.2,0,0,0-2.57-1c-1.83-.61-3.6-2.38-3.06-4.23s3.19-2.55,4-4.4c.69-1.63-.41-3.54-1.87-4.54s-3.25-1.41-4.86-2.17-3.16-2.1-3.29-3.87,1.23-3.34,2.34-4.78,2.05-3.46,1.08-5-3-1.56-4.67-2.09A7.63,7.63,0,0,1,367,81.58c-.44-1-.66-2.14-1.19-3.12-1.65-3.06-5.81-4.39-9-4a3.67,3.67,0,0,0-3.07,2.08,4.86,4.86,0,0,0-1.12,2.12c-.25,1.47.53,3.35-.86,4.47-2.11,1.71-5.35-.59-5.24,3.24a16.35,16.35,0,0,0,.72,4.76c.57,1.61,1.73,2.3.77,4.1-1.24,2.34-2.06,2.32-4.54,2.32-1.81,0-3.31-.1-4.63,1.27-2.32,2.4-.94,4.57,1.12,6.42,2.34,2.11,1.1,3,.8,5.76-.15,1.31.15,1.71-1,2.59-2.22,1.64-3.46,1.09-2.83,4.32.57,2.94-.31,1.93-2.86,3-2.27,1-3.76,3.41-5.6,4.93-1.17,1-3,1.74-3.08,3.45-.22,3.29,3.87,2.57,5.81,3.35,3.17,1.29,2.23,5.45-.25,7s-6.45,2.26-6.66,6c-.16,2.88,1.48,3.52,3.72,4.49,1.79.77,1.56,1,1.56,3.13,0,4.3,1.44,5.52,5.68,4.82,1.17-.2,2.94-.69,4.1-.34,1.62.49,1.07.89,1.12,2.24.11,3.48,4.16,2.5,5.87,1C348.29,159.32,350.77,157.33,353.45,157.07Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.8,149.74c1.93-.63,4.2-.14,6.11-.58a21.68,21.68,0,0,0-3.42-.54,9.62,9.62,0,0,0-4.86,1,4.57,4.57,0,0,0-1.72,1.15A2.15,2.15,0,0,0,382,153c.32.76.82,1.94,0,2.57s-2.37.47-3.33.13a29.77,29.77,0,0,1-3.48-1.63,16.63,16.63,0,0,0-3.44-1.42c-.86-.21-2.37-.32-2.91.61a3.91,3.91,0,0,0-.58,1.87,3.94,3.94,0,0,1,0,1.49,2.91,2.91,0,0,1-2.05,2.18,3.69,3.69,0,0,1-3.5-1.68c-.82-1.09-1.33-2.39-2.16-3.48a7.37,7.37,0,0,0-9.77-1.42c-1.24.9-2.8,2.26-4,1.36s-.52-3.58-2-4.31c-1-.49-2.35.29-3.16-.44a2.13,2.13,0,0,1-.56-1.19c-.59-2.46-1.09-5.3.45-7.29,1.38-1.78,4.29-2.87,4-5.1-.27-1.9-2.69-2.47-4.59-2.7s-4.32-1.12-4.23-3,2.64-2.79,3-4.63c.16-.79-.11-1.67.25-2.39.55-1.08,2.1-1.13,3-1.93,1.63-1.44.36-4.14.83-6.27.32-1.51,1.54-2.69,1.95-4.18.8-3-1.9-5.8-4.73-7a16.83,16.83,0,0,1-3.22-1.49.39.39,0,0,1-.1-.08,5.85,5.85,0,0,0,2.32,3.72c2.34,2.11,1.1,3,.8,5.76-.15,1.31.15,1.71-1,2.59-2.22,1.64-3.46,1.09-2.83,4.32.57,2.94-.31,1.93-2.86,3-2.27,1-3.76,3.41-5.6,4.93-1.18,1-3,1.74-3.08,3.45-.22,3.29,3.87,2.57,5.81,3.35,3.17,1.29,2.23,5.45-.25,7s-6.45,2.26-6.66,6c-.16,2.88,1.48,3.52,3.72,4.49,1.79.77,1.56,1,1.56,3.13,0,4.3,1.44,5.52,5.68,4.82,1.17-.2,2.94-.69,4.1-.34,1.62.49,1.07.89,1.12,2.24.11,3.48,4.16,2.5,5.87,1,2-1.71,4.45-3.7,7.13-4a5.75,5.75,0,0,1,3.12.56,31.6,31.6,0,0,1,5.1,3.61,10.29,10.29,0,0,0,5.66,2.44c2.08.07,4.33-1.23,4.71-3.28a3.06,3.06,0,0,1,.26-1,1.52,1.52,0,0,1,1.78-.46,9.23,9.23,0,0,1,1.72,1c2.11,1.24,4.75,1,7.18.61,2-.29,4.56-1.19,4.55-3.22,0-1.33-1.16-2.31-2.08-3.28s-1.66-2.51-.82-3.54A2.41,2.41,0,0,1,385.8,149.74Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.08,117l13.07,25.91V131l1.33-31,1.93,31v8l14.36-25.1L361.41,144.7v65.14a.83.83,0,0,1-.48.67,2.52,2.52,0,0,1-2.3,0,.83.83,0,0,1-.48-.67V149.49Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tree--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--tree--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.27,112.51a5.73,5.73,0,0,1,3.12.56,31.6,31.6,0,0,1,5.1,3.61,10.29,10.29,0,0,0,5.66,2.44c2.08.07,4.33-1.23,4.71-3.28a2.86,2.86,0,0,1,.27-1,1.52,1.52,0,0,1,1.78-.46,9.49,9.49,0,0,1,1.71,1c2.11,1.24,4.75,1,7.18.61,2-.29,4.56-1.18,4.55-3.22,0-1.33-1.16-2.31-2.08-3.28s-1.65-2.51-.82-3.54a2.41,2.41,0,0,1,1.17-.72c2.52-.82,5.6.27,7.74-1.3a4.45,4.45,0,0,0,1.11-5.34,6.78,6.78,0,0,0-4.54-3.46c-1.69-.43-3.84-.63-4.47-2.26-.56-1.43.55-3,1.81-3.85s2.76-1.49,3.63-2.75a4.35,4.35,0,0,0,.13-4.51,5.51,5.51,0,0,0-3.8-2.61,8.5,8.5,0,0,1-2.31-.5,1.55,1.55,0,0,1-.85-1.95c.23-.41.71-.63,1-1a1.83,1.83,0,0,0-.68-2.4,9.2,9.2,0,0,0-2.57-1c-1.83-.61-3.6-2.38-3.06-4.23s3.19-2.55,4-4.4c.69-1.63-.41-3.54-1.87-4.54s-3.25-1.41-4.86-2.17-3.16-2.1-3.29-3.87,1.23-3.34,2.34-4.78,2.05-3.46,1.08-5-3-1.56-4.66-2.09a7.62,7.62,0,0,1-4.6-4.15c-.44-1-.66-2.14-1.19-3.12-1.65-3.06-5.81-4.39-9-4A3.66,3.66,0,0,0,276.57,32a4.77,4.77,0,0,0-1.12,2.11c-.25,1.47.53,3.35-.86,4.47-2.11,1.71-5.35-.59-5.23,3.24a16,16,0,0,0,.71,4.76c.57,1.61,1.73,2.31.77,4.1C269.6,53,268.79,53,266.3,53c-1.8,0-3.31-.1-4.63,1.27-2.32,2.4-.94,4.57,1.12,6.42,2.35,2.11,1.1,3,.8,5.76-.15,1.31.15,1.72-1,2.59-2.22,1.64-3.46,1.09-2.83,4.32.57,2.94-.31,1.93-2.86,3-2.27,1-3.76,3.41-5.6,4.93-1.17,1-3,1.74-3.08,3.45C248,88,252.06,87.31,254,88.09c3.18,1.29,2.23,5.45-.25,7s-6.45,2.25-6.66,6c-.16,2.88,1.48,3.52,3.72,4.49,1.79.77,1.56,1,1.56,3.13,0,4.3,1.44,5.52,5.68,4.82,1.17-.2,2.94-.69,4.1-.34,1.62.49,1.07.89,1.12,2.24.11,3.48,4.16,2.5,5.87,1C271.11,114.76,273.59,112.77,276.27,112.51Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.27,112.51a5.73,5.73,0,0,1,3.12.56,31.6,31.6,0,0,1,5.1,3.61,10.29,10.29,0,0,0,5.66,2.44c2.08.07,4.33-1.23,4.71-3.28a2.86,2.86,0,0,1,.27-1,1.52,1.52,0,0,1,1.78-.46,9.49,9.49,0,0,1,1.71,1c2.11,1.24,4.75,1,7.18.61,2-.29,4.56-1.18,4.55-3.22,0-1.33-1.16-2.31-2.08-3.28s-1.65-2.51-.82-3.54a2.41,2.41,0,0,1,1.17-.72c2.52-.82,5.6.27,7.74-1.3a4.45,4.45,0,0,0,1.11-5.34,6.78,6.78,0,0,0-4.54-3.46c-1.69-.43-3.84-.63-4.47-2.26-.56-1.43.55-3,1.81-3.85s2.76-1.49,3.63-2.75a4.35,4.35,0,0,0,.13-4.51,5.51,5.51,0,0,0-3.8-2.61,8.5,8.5,0,0,1-2.31-.5,1.55,1.55,0,0,1-.85-1.95c.23-.41.71-.63,1-1a1.83,1.83,0,0,0-.68-2.4,9.2,9.2,0,0,0-2.57-1c-1.83-.61-3.6-2.38-3.06-4.23s3.19-2.55,4-4.4c.69-1.63-.41-3.54-1.87-4.54s-3.25-1.41-4.86-2.17-3.16-2.1-3.29-3.87,1.23-3.34,2.34-4.78,2.05-3.46,1.08-5-3-1.56-4.66-2.09a7.62,7.62,0,0,1-4.6-4.15c-.44-1-.66-2.14-1.19-3.12-1.65-3.06-5.81-4.39-9-4A3.66,3.66,0,0,0,276.57,32a4.77,4.77,0,0,0-1.12,2.11c-.25,1.47.53,3.35-.86,4.47-2.11,1.71-5.35-.59-5.23,3.24a16,16,0,0,0,.71,4.76c.57,1.61,1.73,2.31.77,4.1C269.6,53,268.79,53,266.3,53c-1.8,0-3.31-.1-4.63,1.27-2.32,2.4-.94,4.57,1.12,6.42,2.35,2.11,1.1,3,.8,5.76-.15,1.31.15,1.72-1,2.59-2.22,1.64-3.46,1.09-2.83,4.32.57,2.94-.31,1.93-2.86,3-2.27,1-3.76,3.41-5.6,4.93-1.17,1-3,1.74-3.08,3.45C248,88,252.06,87.31,254,88.09c3.18,1.29,2.23,5.45-.25,7s-6.45,2.25-6.66,6c-.16,2.88,1.48,3.52,3.72,4.49,1.79.77,1.56,1,1.56,3.13,0,4.3,1.44,5.52,5.68,4.82,1.17-.2,2.94-.69,4.1-.34,1.62.49,1.07.89,1.12,2.24.11,3.48,4.16,2.5,5.87,1C271.11,114.76,273.59,112.77,276.27,112.51Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.62,105.18c1.93-.63,4.2-.13,6.11-.58a21.68,21.68,0,0,0-3.42-.54,9.62,9.62,0,0,0-4.86,1,4.46,4.46,0,0,0-1.71,1.15,2.12,2.12,0,0,0,.06,2.15c.32.76.82,1.94.05,2.57s-2.37.47-3.33.13a29.77,29.77,0,0,1-3.48-1.63,16.41,16.41,0,0,0-3.44-1.42c-.86-.21-2.37-.32-2.91.61a3.91,3.91,0,0,0-.58,1.87,3.74,3.74,0,0,1,0,1.49,2.91,2.91,0,0,1-2.05,2.18,3.67,3.67,0,0,1-3.49-1.68c-.83-1.09-1.34-2.39-2.17-3.47a7.36,7.36,0,0,0-9.77-1.43c-1.24.9-2.8,2.26-4,1.36s-.52-3.58-2-4.31c-1-.49-2.35.29-3.16-.43a2.2,2.2,0,0,1-.56-1.2c-.58-2.46-1.09-5.3.45-7.29,1.38-1.78,4.29-2.87,4-5.1-.27-1.9-2.69-2.47-4.59-2.7s-4.32-1.12-4.23-3,2.65-2.78,3-4.63c.16-.79-.11-1.67.25-2.39.55-1.08,2.1-1.13,3-1.93,1.63-1.44.36-4.14.83-6.27.32-1.51,1.54-2.69,1.95-4.18.8-3-1.9-5.8-4.73-7A16.83,16.83,0,0,1,260.57,57a.39.39,0,0,1-.1-.08,5.89,5.89,0,0,0,2.32,3.72c2.35,2.11,1.1,3,.8,5.76-.15,1.31.15,1.72-1,2.59-2.22,1.64-3.46,1.09-2.83,4.32.57,2.94-.31,1.93-2.86,3-2.27,1-3.76,3.41-5.6,4.93-1.17,1-3,1.74-3.08,3.45C248,88,252.06,87.31,254,88.09c3.18,1.29,2.23,5.45-.25,7s-6.45,2.25-6.66,6c-.16,2.88,1.48,3.52,3.72,4.49,1.79.77,1.56,1,1.56,3.13,0,4.3,1.44,5.52,5.68,4.82,1.17-.2,2.94-.69,4.1-.34,1.62.49,1.07.89,1.12,2.24.11,3.48,4.16,2.5,5.87,1,2-1.71,4.45-3.7,7.13-4a5.73,5.73,0,0,1,3.12.56,31.6,31.6,0,0,1,5.1,3.61,10.29,10.29,0,0,0,5.66,2.44c2.08.07,4.33-1.23,4.71-3.28a2.86,2.86,0,0,1,.27-1,1.52,1.52,0,0,1,1.78-.46,9.49,9.49,0,0,1,1.71,1c2.11,1.24,4.75,1,7.18.61,2-.29,4.56-1.18,4.55-3.22,0-1.33-1.16-2.31-2.08-3.28s-1.65-2.51-.82-3.54A2.41,2.41,0,0,1,308.62,105.18Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.9,72.42,281,98.33V86.41l1.33-31,1.93,31v8l14.36-25.1-14.36,30.82v65.14a.81.81,0,0,1-.48.67,2.52,2.52,0,0,1-2.3,0,.81.81,0,0,1-.48-.67V104.94Z",
    style: {
      fill: "#263238"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sidewalk--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--sidewalk--inject-64"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "169.29 195.32 404.89 331.35 404.89 339.45 169.29 203.43 169.29 195.32",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "404.89 331.35 461.05 298.93 225.45 162.9 169.29 195.32 404.89 331.35",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "404.89 339.45 461.05 307.03 461.05 298.93 404.89 331.35 404.89 339.45",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.29 298.67 404.45 266.25 400.94 264.22 344.78 296.65 348.29 298.67",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.63 264.22 344.78 231.8 341.27 229.77 285.12 262.2 288.63 264.22",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.96 229.77 285.12 197.35 281.61 195.32 225.45 227.75 228.96 229.77",
    style: {
      fill: "#ebebeb"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Parking--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--parking--inject-64"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "404.89 339.45 246.47 430.92 10.87 294.89 169.29 203.43 404.89 339.45",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.63,373.93c-7.88-4.54-7.88-11.94,0-16.49,4.33-2.5,10.16-3.62,15.84-3.37l5.31-3.77c-9.12-1.35-19.21,0-26.34,4.15-10.73,6.2-10.73,16.28,0,22.48,6.8,3.92,16.29,5.36,25.06,4.32l3.94-5.28C274.8,378.33,265.06,377.65,258.63,373.93Zm40.26,14.12c.68-1.1-.31-2.31-2.22-2.7l-7.34-1.51,9.4-12.63c.6-.8.23-1.69-.83-2.3l-16.12-9.31,4.36-3.09,12.46,7.2a5.66,5.66,0,0,0,5.16,0c1.43-.83,1.4-2.15,0-3l-13-7.49,7-5a12.56,12.56,0,0,0,10-.57c3.1-1.79,3.1-4.68,0-6.47a12.41,12.41,0,0,0-11.2,0,4.24,4.24,0,0,0-2.29,2.82l-10.87,7.7-.18.1a2.64,2.64,0,0,0-.6.46l-8.4,5.95c-1.18.84-1,2,.37,2.77l16.7,9.64-10.1,13.47a1.42,1.42,0,0,0-.11,1.74,2.65,2.65,0,0,0,.77.66,4.36,4.36,0,0,0,1.36.49l11,2.28C296.11,389.72,298.21,389.15,298.89,388.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.58 249.68 217.34 241.7 222.86 238.51 225.63 243.3 214.58 249.68",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.62 213 217.34 241.7 222.86 238.51 173.15 209.81 167.62 213",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.62 213 217.34 241.7 222.86 238.51 173.15 209.81 167.62 213",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.62 213 164.86 220.97 214.58 249.68 217.34 241.7 167.62 213",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.62 213 164.86 220.97 214.58 249.68 217.34 241.7 167.62 213",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.89 218.66 170.96 221.34 187.71 231.01 188.65 228.33 171.89 218.66",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.81 231.31 192.88 234 209.63 243.67 210.56 240.98 193.81 231.31",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.81 250.33 95.64 332.42 99.7 334.76 241.88 252.68 237.81 250.33",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.76 294.24 294.52 286.26 300.04 283.07 302.81 287.86 291.76 294.24",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.8 257.56 294.52 286.26 300.04 283.07 250.32 254.37 244.8 257.56",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.8 257.56 294.52 286.26 300.04 283.07 250.32 254.37 244.8 257.56",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.8 257.56 242.04 265.53 291.76 294.24 294.52 286.26 244.8 257.56",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.8 257.56 242.04 265.53 291.76 294.24 294.52 286.26 244.8 257.56",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.07 263.21 248.14 265.9 264.89 275.57 265.82 272.89 249.07 263.21",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.99 275.87 270.06 278.56 286.81 288.23 287.74 285.54 270.99 275.87",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.99 294.89 172.82 376.98 176.88 379.32 319.05 297.24 314.99 294.89",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373 341.14 375.76 333.17 381.28 329.98 384.05 334.76 373 341.14",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.04 304.46 375.76 333.17 381.28 329.98 331.56 301.27 326.04 304.46",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.04 304.46 375.76 333.17 381.28 329.98 331.56 301.27 326.04 304.46",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.04 304.46 323.28 312.44 373 341.14 375.76 333.17 326.04 304.46",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.04 304.46 323.28 312.44 373 341.14 375.76 333.17 326.04 304.46",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.31 310.12 329.38 312.81 346.13 322.48 347.06 319.79 330.31 310.12",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.23 322.77 351.3 325.46 368.05 335.13 368.98 332.44 352.23 322.77",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Signals--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Signal--inject-64"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "270.32 149.34 270.32 272.29 271.64 271.53 271.64 148.56 270.32 149.34",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.21 148.11 268.21 271.08 270.32 272.29 270.32 149.34 268.21 148.11",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.21 148.11 270.32 149.34 271.64 148.56 269.53 147.35 268.21 148.11",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.15,158.83l-20.85-12a1,1,0,0,0-1-.09l-1.12.65a1,1,0,0,0-.4.9v30.14a3.08,3.08,0,0,0,1.4,2.42l20.84,12a1,1,0,0,0,1,.09l1.14-.65a1,1,0,0,0,.39-.9V161.26A3.11,3.11,0,0,0,280.15,158.83Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.15,158.83l-20.85-12a1,1,0,0,0-1-.09l-1.12.65a1,1,0,0,0-.4.9v30.14a3.08,3.08,0,0,0,1.4,2.42l20.84,12a1,1,0,0,0,1,.09l1.14-.65a1,1,0,0,0,.39-.9V161.26A3.11,3.11,0,0,0,280.15,158.83Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,192.94c.19-.11.94-.53,1.14-.66a1,1,0,0,0,.39-.89V161.26a2.69,2.69,0,0,0-.28-1.12L279,161.43v31.42h0A1,1,0,0,0,280,192.94Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,192.94c.19-.11.94-.53,1.14-.66a1,1,0,0,0,.39-.89V161.26a2.69,2.69,0,0,0-.28-1.12L279,161.43v31.42h0A1,1,0,0,0,280,192.94Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279,159.48l-20.84-12c-.78-.45-1.4-.08-1.4.81v30.14a3.08,3.08,0,0,0,1.4,2.42l20.84,12c.77.44,1.4.08,1.4-.81V161.9A3.09,3.09,0,0,0,279,159.48Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.79,150.1,278,161.21a1.25,1.25,0,0,1,.4.69v28.29l-19.24-11.11a1.19,1.19,0,0,1-.4-.69V150.1m-.5-.87v29.16a1.65,1.65,0,0,0,.65,1.12l20,11.54V161.9a1.65,1.65,0,0,0-.65-1.13l-20-11.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.52,179.26c-2.09-1.21-3.79-4.81-3.79-8a4.51,4.51,0,0,1,1.32-3.67l-.16-2.51c-1.52.51-2.54,2.47-2.54,5.39,0,4.39,2.32,9.31,5.17,10.95a2.89,2.89,0,0,0,4.33-1.1l-.69-3.07C270.68,179.33,269.23,180.25,267.52,179.26Zm8.6,1.73c-.16-.62-.57-1.08-.91-1l-1.33.2-1.65-7.36a1.58,1.58,0,0,0-.65-1l-4.28-2.48-.13-2.06,3.31,1.92c.38.22.69-.07.69-.65a1.8,1.8,0,0,0-.69-1.45l-3.45-2-.21-3.32c.68.19,1.2-.44,1.2-1.56a4,4,0,0,0-1.49-3.15c-.82-.47-1.49.17-1.49,1.43a4.57,4.57,0,0,0,.34,1.67l.33,5.14v.07a1.53,1.53,0,0,0,0,.3l.25,4a1.67,1.67,0,0,0,.69,1.3l4.44,2.56,1.75,7.86a2.27,2.27,0,0,0,.39.86,1,1,0,0,0,.25.22.51.51,0,0,0,.3.07l2-.3C276.14,182.16,276.29,181.62,276.12,181Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--signal--inject-64"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "351.57 196.24 351.57 319.19 352.89 318.43 352.89 195.46 351.57 196.24",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.47 195 349.47 317.97 351.57 319.19 351.57 196.24 349.47 195",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.47 195 351.57 196.24 352.89 195.46 350.78 194.25 349.47 195",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.4,205.73l-20.84-12a1,1,0,0,0-1-.09c-.19.12-.92.53-1.11.64a1,1,0,0,0-.41.91v30.13a3.08,3.08,0,0,0,1.4,2.43l20.84,12a1,1,0,0,0,1,.1c.2-.11.94-.53,1.14-.66a1,1,0,0,0,.39-.89V208.15A3.09,3.09,0,0,0,361.4,205.73Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.4,205.73l-20.84-12a1,1,0,0,0-1-.09c-.19.12-.92.53-1.11.64a1,1,0,0,0-.41.91v30.13a3.08,3.08,0,0,0,1.4,2.43l20.84,12a1,1,0,0,0,1,.1c.2-.11.94-.53,1.14-.66a1,1,0,0,0,.39-.89V208.15A3.09,3.09,0,0,0,361.4,205.73Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.27,239.84c.2-.11.94-.53,1.14-.66a1,1,0,0,0,.39-.89V208.15a2.61,2.61,0,0,0-.28-1.12l-2.24,1.3v31.41h0A1,1,0,0,0,361.27,239.84Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.27,239.84c.2-.11.94-.53,1.14-.66a1,1,0,0,0,.39-.89V208.15a2.61,2.61,0,0,0-.28-1.12l-2.24,1.3v31.41h0A1,1,0,0,0,361.27,239.84Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.28,206.37l-20.84-12c-.78-.45-1.4-.09-1.4.81v30.13a3.08,3.08,0,0,0,1.4,2.43l20.84,12c.78.45,1.4.09,1.4-.8V208.8A3.1,3.1,0,0,0,360.28,206.37Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,197l19.24,11.12a1.16,1.16,0,0,1,.4.69v28.29L340.44,226a1.18,1.18,0,0,1-.4-.7V197m-.5-.86v29.15a1.65,1.65,0,0,0,.65,1.13l20,11.54V208.8a1.65,1.65,0,0,0-.65-1.13l-20-11.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.77,226.16c-2.09-1.21-3.79-4.82-3.79-8,0-1.77.51-3.06,1.33-3.67l-.16-2.51c-1.53.5-2.55,2.47-2.55,5.39,0,4.39,2.32,9.3,5.17,10.95a2.9,2.9,0,0,0,4.33-1.1l-.69-3.07C351.93,226.23,350.48,227.15,348.77,226.16Zm8.61,1.73c-.17-.62-.58-1.09-.92-1l-1.32.2-1.66-7.36a1.61,1.61,0,0,0-.64-1l-4.29-2.48-.13-2.06,3.31,1.91c.38.22.69-.06.69-.65a1.79,1.79,0,0,0-.69-1.44l-3.45-2-.21-3.32c.69.18,1.2-.45,1.2-1.56a3.92,3.92,0,0,0-1.49-3.15c-.82-.48-1.49.17-1.49,1.43a4.42,4.42,0,0,0,.35,1.67l.33,5.14a.17.17,0,0,0,0,.07,1.53,1.53,0,0,0,0,.3l.25,4a1.72,1.72,0,0,0,.69,1.31l4.44,2.56,1.76,7.85a2.23,2.23,0,0,0,.38.87,1,1,0,0,0,.26.22.46.46,0,0,0,.29.07l2-.3C357.39,229.06,357.54,228.51,357.38,227.89Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--signal--inject-64"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "193.1 104.75 193.1 227.71 194.42 226.95 194.42 103.98 193.1 104.75",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.99 103.52 190.99 226.49 193.1 227.71 193.1 104.75 190.99 103.52",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.99 103.52 193.1 104.75 194.42 103.98 192.31 102.76 190.99 103.52",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.93,114.25l-20.85-12a1,1,0,0,0-1-.09l-1.12.64a1,1,0,0,0-.41.91V133.8a3.11,3.11,0,0,0,1.4,2.43l20.85,12a1,1,0,0,0,1,.1l1.14-.66a1,1,0,0,0,.39-.89V116.67A3.09,3.09,0,0,0,202.93,114.25Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.93,114.25l-20.85-12a1,1,0,0,0-1-.09l-1.12.64a1,1,0,0,0-.41.91V133.8a3.11,3.11,0,0,0,1.4,2.43l20.85,12a1,1,0,0,0,1,.1l1.14-.66a1,1,0,0,0,.39-.89V116.67A3.09,3.09,0,0,0,202.93,114.25Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.8,148.36l1.14-.66a1,1,0,0,0,.39-.89V116.67a2.76,2.76,0,0,0-.28-1.12l-2.24,1.3v31.41h0A1,1,0,0,0,202.8,148.36Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.8,148.36l1.14-.66a1,1,0,0,0,.39-.89V116.67a2.76,2.76,0,0,0-.28-1.12l-2.24,1.3v31.41h0A1,1,0,0,0,202.8,148.36Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.81,114.89l-20.85-12c-.77-.45-1.4-.09-1.4.81V133.8a3.11,3.11,0,0,0,1.4,2.43l20.85,12c.77.45,1.4.09,1.4-.81V117.32A3.11,3.11,0,0,0,201.81,114.89Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.56,105.51l19.25,11.11a1.27,1.27,0,0,1,.4.7V145.6L182,134.5a1.27,1.27,0,0,1-.4-.7V105.51m-.5-.86V133.8a1.65,1.65,0,0,0,.65,1.13l20,11.54V117.32a1.65,1.65,0,0,0-.65-1.13l-20-11.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.09,119.93a12.22,12.22,0,0,1,1.3,5.66,9.44,9.44,0,0,1-.45,3.08,2.65,2.65,0,0,1-1.46,1.71,3,3,0,0,1-2.61-.51l-1.82-1.05v6.3l-2.55-1.47v-19.9l3.92,2.26A9.28,9.28,0,0,1,195.09,119.93ZM193,126.22a1.45,1.45,0,0,0,.63-.81,3.6,3.6,0,0,0,.19-1.18,7.21,7.21,0,0,0-.4-2.28,3.35,3.35,0,0,0-1.57-1.89L190.05,119v6l1.81,1A1.15,1.15,0,0,0,193,126.22Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-64",
    d: "M190.64,274.88l-20.86,12c-1.61.92-3.72,1.2-4.72.62s-3.11-.29-4.72.63l-30.59,17.59c-1.61.92-2,2.12-1,2.67s.64,1.74-1,2.66L104.6,324.31a6.43,6.43,0,0,1-5.81,0l-8.67-5c-1.61-.92-3.72-1.2-4.72-.63s-3.11.29-4.71-.63L44.86,297.47c-1.61-.92-2.1-2.14-1.1-2.71s.51-1.79-1.09-2.71l-8.67-5c-1.61-.92-1.61-2.41,0-3.33l86-49.42a6.42,6.42,0,0,1,5.82,0l64.79,37.24C192.24,272.47,192.24,274,190.64,274.88Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-64",
    d: "M115.21,343.69c-4.78-2.76-4.78-7.23,0-10l83.16-48c14.35-8.28,37.61-8.28,52,0l9,5.18c14.35,8.29,14.35,21.72,0,30l-83.16,48c-4.78,2.76-12.53,2.76-17.32,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-64",
    points: "429.93 407.21 455.3 392.56 477.05 405.12 451.68 419.77 429.93 407.21",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-64",
    d: "M47.52,414.05c-3.12,0-6.27,0-9.37-.08s-5.91-1.07-7.4-2.8a4.75,4.75,0,0,1-1.19-3.75L32,388.13c.41-3.34,4.43-6.13,9.56-6.64,18.73-1.85,37.67-2.79,56.31-2.79,3.08,0,6.21,0,9.3.07s5.91,1.08,7.41,2.8a4.76,4.76,0,0,1,1.2,3.74l-2.4,19.3c-.43,3.35-4.46,6.14-9.59,6.63-18.9,1.87-37.82,2.81-56.22,2.81Zm57.92-13.18a2.32,2.32,0,0,0,.94-.22l1.44-11.6h-.25a2.5,2.5,0,0,0-.94.23l-1.44,11.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-64",
    d: "M71.67,453.14l3.78-1.24,1-1.07,1,0,.54-1,2.63-.91,2-2.55L87,445l.67-2,14.56-8.4a8.13,8.13,0,0,1-1.14-5.07c.37-3.33,2.76-6.5,6.74-8.93l13.81-8.45a19.54,19.54,0,0,1,9.92-2.6,16.29,16.29,0,0,1,7,1.44,92.81,92.81,0,0,1,13,7.56,6,6,0,0,1,2.87,5.34c-.14,2.51-2,4.92-5.07,6.6l-14.62,8a31.77,31.77,0,0,1-15,3.61h0a29.41,29.41,0,0,1-7-.81L97,450.31l-3.6.41-2.54,2.62-4.43,1.19L84.94,456l-1.36.25-.07.6-2.21.66-2.06,2.09L68.52,461Zm58.18-37a91.59,91.59,0,0,1,12.9,7.5,7.3,7.3,0,0,1,1.76,1.69l.21-.11c1-.55,1.35-1.11,1.36-1.29s-.08-.17-.33-.35c-1.94-1.35-3.93-2.62-5.91-3.76s-3.92-2.16-6.09-3.2a6.7,6.7,0,0,0-2.81-.55A10,10,0,0,0,129.85,416.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-64",
    d: "M186.16,461.07l15.9-9.18a.65.65,0,0,0,0-1.23l-15.9-9.18a2.35,2.35,0,0,0-2.13,0l-15.9,9.18a.65.65,0,0,0,0,1.23l15.9,9.18A2.35,2.35,0,0,0,186.16,461.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-64",
    d: "M370.73,459.63l15.9-9.18a.65.65,0,0,0,0-1.23L370.73,440a2.35,2.35,0,0,0-2.13,0l-15.9,9.18a.65.65,0,0,0,0,1.23l15.9,9.18A2.35,2.35,0,0,0,370.73,459.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-64",
    d: "M411.58,453.68l15.89-9.18c.59-.34.59-.89,0-1.24l-15.89-9.17a2.37,2.37,0,0,0-2.14,0l-15.9,9.17c-.59.35-.59.9,0,1.24l15.9,9.18A2.37,2.37,0,0,0,411.58,453.68Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--car-2--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Vehicle--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--4x4--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--percentage-box--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.41,222.52l-3.61-2.09a.82.82,0,0,0-.84-.08l-.85.5a.82.82,0,0,0-.35.77v8.66a2.63,2.63,0,0,0,1.18,2.05l3.61,2.09a.83.83,0,0,0,.83.09l.86-.51a.83.83,0,0,0,.35-.77v-8.66A2.63,2.63,0,0,0,77.41,222.52Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.59,224.57v8.66a.83.83,0,0,1-.35.77l-.83.49a.85.85,0,0,0,.32-.75v-8.66a2.33,2.33,0,0,0-.35-1.16l.86-.51A2.33,2.33,0,0,1,78.59,224.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.94,232.33l3.61,2.09c.65.38,1.18.07,1.18-.68v-8.66A2.63,2.63,0,0,0,76.55,223l-3.61-2.09c-.65-.38-1.18-.08-1.18.68v8.66A2.63,2.63,0,0,0,72.94,232.33Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M79.67,240.7a.28.28,0,0,1-.15,0L75,238a.92.92,0,0,1-.45-.78v-9.48a.3.3,0,0,1,.3-.3.29.29,0,0,1,.3.3v9.48a.3.3,0,0,0,.15.26l4.57,2.64a.29.29,0,0,1,.11.4A.3.3,0,0,1,79.67,240.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.73,272.52a1.76,1.76,0,0,0,.57-1.12c.08-.6.19-1.2.32-1.79a1.21,1.21,0,0,0-.06-.88l-.18-.1c-.17-.1-.19-.5,0-.94l1.13-3.27c.17-.48.48-.84.7-.8s.57-.3.8-.77.56-1.12.87-1.66a1.52,1.52,0,0,0,.23-1.2,1.28,1.28,0,0,1,.3-1.11l2-2.64c.25-.33.53-.48.68-.39l.34.2a1,1,0,0,0,.55-.32,15.36,15.36,0,0,1,1.19-1.11,1.74,1.74,0,0,0,.6-1.12,1.27,1.27,0,0,1,.61-1l2.26-1.3a.47.47,0,0,1,.46-.06l1.11.64c.28-.07.56-.12.83-.16a1.1,1.1,0,0,0,.8-.73.77.77,0,0,1,.76-.57l2,.38.13.05,9.72,5.62a.52.52,0,0,1,.21.58l2.41,1.4a.41.41,0,0,1,.16.16l1.13,2a1,1,0,0,1-.09,1.05,1.51,1.51,0,0,0-.18,1.18,11.65,11.65,0,0,1,.32,1.41l.81.46a.66.66,0,0,1,.21.57v3a1.36,1.36,0,0,1-.45,1.07,1.71,1.71,0,0,0-.55,1.11c-.09.6-.19,1.2-.32,1.81a1.18,1.18,0,0,0,.06.87l.17.1c.16.1.18.49,0,.93l-1.13,3.27c-.17.49-.47.85-.68.81s-.55.31-.78.77-.57,1.15-.89,1.71a1.51,1.51,0,0,0-.24,1.17c.12.21,0,.69-.31,1.09l-2,2.64c-.25.33-.53.49-.68.4l-.29-.17a1,1,0,0,0-.56.34c-.4.4-.81.79-1.23,1.15a1.66,1.66,0,0,0-.6,1.06,1.22,1.22,0,0,1-.61.92L59,290.56a.46.46,0,0,1-.47.06c-.09,0-1-.58-1-.58a6.65,6.65,0,0,1-.95.19,1.1,1.1,0,0,0-.79.68.72.72,0,0,1-.74.52l-2-.38A.24.24,0,0,1,53,291l-9.72-5.61a.53.53,0,0,1-.21-.59l-2.39-1.38a.49.49,0,0,1-.17-.18l-1.13-2a1,1,0,0,1,.07-1,1.43,1.43,0,0,0,.18-1.16c-.13-.46-.23-.93-.32-1.43v0l-.79-.45a.66.66,0,0,1-.21-.57v-3A1.36,1.36,0,0,1,38.73,272.52Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,282.23v-3a1.33,1.33,0,0,1,.45-1.07A1.75,1.75,0,0,0,49,277c.09-.59.2-1.19.33-1.79s0-.91-.19-1-.26-.47-.09-1L50.2,270c.17-.48.49-.84.71-.8s.57-.31.79-.77.57-1.12.88-1.67a1.5,1.5,0,0,0,.23-1.19c-.13-.22,0-.72.3-1.11l2-2.64c.29-.4.63-.53.76-.31s.48.12.8-.2.79-.77,1.19-1.12a1.7,1.7,0,0,0,.6-1.11,1.27,1.27,0,0,1,.61-1l2.27-1.3c.33-.2.6-.08.6.26a.43.43,0,0,0,.6.42,9.48,9.48,0,0,1,1.19-.26,1.13,1.13,0,0,0,.81-.73.77.77,0,0,1,.76-.57l2,.38c.29.06.42.4.3.77a.78.78,0,0,0,.23.92,5.54,5.54,0,0,1,.87.66.54.54,0,0,0,.8-.15c.22-.29.53-.3.7,0l1.13,2a1,1,0,0,1-.09,1.05,1.51,1.51,0,0,0-.18,1.18,11.65,11.65,0,0,1,.32,1.41c.07.4.32.62.57.48s.45.1.45.55v3a1.36,1.36,0,0,1-.45,1.07,1.71,1.71,0,0,0-.55,1.11c-.09.6-.19,1.2-.32,1.81s0,.91.18.95.24.47.07.95l-1.13,3.27c-.17.49-.47.85-.68.81s-.55.31-.78.77-.57,1.15-.89,1.71a1.51,1.51,0,0,0-.24,1.17c.12.21,0,.69-.31,1.09l-2,2.64c-.29.39-.63.54-.74.34s-.47-.1-.79.23-.81.79-1.23,1.15a1.66,1.66,0,0,0-.6,1.06,1.22,1.22,0,0,1-.61.92L59,290.56c-.34.19-.61.1-.61-.22s-.27-.47-.6-.37a8.08,8.08,0,0,1-1.22.26,1.1,1.1,0,0,0-.79.68.72.72,0,0,1-.74.52l-2-.38c-.3-.05-.43-.38-.31-.72a.77.77,0,0,0-.25-.89,6.36,6.36,0,0,1-.89-.68.51.51,0,0,0-.77.12.39.39,0,0,1-.69,0l-1.13-2a1,1,0,0,1,.08-1,1.51,1.51,0,0,0,.18-1.16,12.17,12.17,0,0,1-.32-1.44c-.07-.4-.31-.62-.56-.48S48,282.68,48,282.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.14,251.81l8.58,5,0,0a.37.37,0,0,1,.14.33.42.42,0,0,0,.6.41l.38-.1a7.73,7.73,0,0,1,.81-.16.91.91,0,0,0,.49-.26l-9.71-5.62a.93.93,0,0,1-.5.26C53.69,251.69,53.42,251.75,53.14,251.81Z",
    style: {
      fill: "#263238"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.46,254.19l9.72,5.62a1.37,1.37,0,0,0,.24-.69,1,1,0,0,1,.18-.53L48.87,253a1.06,1.06,0,0,0-.17.54A1.43,1.43,0,0,1,48.46,254.19Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.37,256l9.33,5.41,0,0a.3.3,0,0,1,.08.08.22.22,0,0,0,.26.11,1,1,0,0,0,.54-.31c.39-.4.79-.77,1.19-1.12a1.63,1.63,0,0,0,.36-.42l-9.72-5.62a2.14,2.14,0,0,1-.36.42,15.64,15.64,0,0,0-1.19,1.12A1,1,0,0,1,46.37,256Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.92,263.72l9.73,5.61a.35.35,0,0,1,.25-.09c.23,0,.57-.31.8-.77s.57-1.12.87-1.67a1.47,1.47,0,0,0,.24-1.19.45.45,0,0,1,0-.29L43,259.7a.44.44,0,0,0,.05.29,1.58,1.58,0,0,1-.24,1.2c-.31.54-.6,1.09-.87,1.66s-.58.82-.8.77A.37.37,0,0,0,40.92,263.72Z",
    style: {
      fill: "#263238"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.65,269.33l-9.73-5.61a.37.37,0,0,1,.26-.1.25.25,0,0,0,.12,0L51,269.22a.21.21,0,0,1-.13,0A.35.35,0,0,0,50.65,269.33Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.09,260a.44.44,0,0,1-.05-.29l9.73,5.62a.45.45,0,0,0,0,.29.7.7,0,0,1,0,.42l-9.72-5.63A.75.75,0,0,0,43.09,260Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.44,272.88l9.73,5.62a.78.78,0,0,1,.29-.36A1.75,1.75,0,0,0,49,277c.09-.6.2-1.2.33-1.79a1.14,1.14,0,0,0-.08-.9h0l-.1-.06-.09-.06-9.51-5.48a1.23,1.23,0,0,1,.07.87c-.14.6-.24,1.2-.33,1.79a1.73,1.73,0,0,1-.57,1.13A1,1,0,0,0,38.44,272.88Z",
    style: {
      fill: "#263238"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.73,272.52a1,1,0,0,0,.34-.42l9.73,5.62a1.07,1.07,0,0,1-.34.42.78.78,0,0,0-.29.36l-9.73-5.62A1,1,0,0,1,38.73,272.52Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.26,280.64,49,286.26a1,1,0,0,1,.17-.4,1.34,1.34,0,0,0,.2-.55,1.38,1.38,0,0,0,0-.61,12.45,12.45,0,0,1-.32-1.43v0c-.08-.39-.31-.61-.55-.47a.26.26,0,0,1-.27,0l-8.91-5.15h0c.09.51.2,1,.32,1.43a1.44,1.44,0,0,1-.18,1.17A.89.89,0,0,0,39.26,280.64Z",
    style: {
      fill: "#263238"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.15,285.86a1,1,0,0,0-.17.4l-9.72-5.62a.89.89,0,0,1,.16-.4,1.12,1.12,0,0,0,.2-.5l9.72,5.61A1.35,1.35,0,0,1,49.15,285.86Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.75,258a6.22,6.22,0,0,1,.87.66.53.53,0,0,0,.8-.15.41.41,0,0,1,.52-.18l0,0L67.55,257l0,.14A.78.78,0,0,0,67.75,258Z",
    style: {
      fill: "#263238"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.25,285.38h0l.15.09L52.89,291l.06,0a.56.56,0,0,1-.15-.67.76.76,0,0,0-.25-.88,5.68,5.68,0,0,1-.89-.68.5.5,0,0,0-.77.12.43.43,0,0,1-.45.19l-.09-.05L43,284.8A.52.52,0,0,0,43.25,285.38Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.56,290l1,.58a.28.28,0,0,1-.14-.28c0-.32-.27-.47-.6-.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3,285.79l.23.13,0,0A.18.18,0,0,0,64.3,285.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.31,264.15c.06.4.31.62.55.47a.33.33,0,0,1,.21,0l-.07,0-.11-.07Z",
    style: {
      fill: "#263238"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.47,251.39,64.18,257a1.19,1.19,0,0,0,.32-.47.92.92,0,0,1,.34-.45l-9.73-5.61a.84.84,0,0,0-.34.45A1.26,1.26,0,0,1,54.47,251.39Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.2,277.38c0,4.9,1.63,8.36,4.21,9.84l1.74,1c-2.54-1.51-4.14-4.94-4.14-9.81,0-9,5.44-19.36,12.16-23.24,2.9-1.68,5.56-1.86,7.65-.81l-1.49-.86c-2.14-1.24-4.92-1.13-8,.63C47.64,258,42.2,268.42,42.2,277.38Z",
    style: {
      fill: "#37474f"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44,278.42c0,4.86,1.6,8.29,4.14,9.8l1.17.67c-2.53-1.5-4.14-4.94-4.14-9.79,0-9,5.45-19.37,12.17-23.25,3-1.73,5.75-1.87,7.87-.68l-1.4-.81c-2.09-1.05-4.75-.87-7.65.81C49.45,259.05,44,269.46,44,278.42Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.11,250.48l9.73,5.61a.56.56,0,0,1,.42-.12l.81.16,1.15.22.08,0-.13-.07-9-5.21L58,251l-.17-.1-.06,0-.09-.06-.06,0-.06,0-.06,0-2-.37A.49.49,0,0,0,55.11,250.48Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.87,253l9.73,5.62a1.29,1.29,0,0,1,.43-.44l2.27-1.3a.49.49,0,0,1,.42-.08l-8.58-5-.72-.41-.26-.15-.14-.08a.47.47,0,0,0-.45.05l-2.26,1.32A1.21,1.21,0,0,0,48.87,253Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,259.7l9.73,5.62a1.74,1.74,0,0,1,.34-.82l2-2.64c.22-.3.47-.45.63-.41L46.37,256l-.34-.19c-.17-.09-.44.06-.69.39l-2,2.64A1.72,1.72,0,0,0,43,259.7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.36,268.61l.06,0,.14.08,9.51,5.48a1,1,0,0,1,0-.9L50.2,270a1.7,1.7,0,0,1,.45-.71l-9.73-5.61a1.7,1.7,0,0,0-.44.71l-1.14,3.26C39.2,268.11,39.21,268.5,39.36,268.61Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.28,273.59v3a.66.66,0,0,0,.21.57l.79.45,8.91,5.15a.69.69,0,0,1-.18-.55v-3a1.6,1.6,0,0,1,.16-.7h0l-9.73-5.62A1.71,1.71,0,0,0,38.28,273.59Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.34,281.28l1.14,2a.33.33,0,0,0,.17.18l.53.31.2.11,1.66,1L50.35,289a.59.59,0,0,1-.15-.16l-1.13-2a1.05,1.05,0,0,1-.09-.64l-9.72-5.62A1,1,0,0,0,39.34,281.28Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.52,277.54c0,4.89,3,7.14,6.64,5s6.65-7.8,6.65-12.69-3-7.15-6.65-5S53.52,272.65,53.52,277.54Zm1.15-.66c0-4.05,2.46-8.75,5.49-10.51s5.5.11,5.5,4.16-2.46,8.75-5.5,10.5S54.67,280.92,54.67,276.88Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.66,276.88a6,6,0,0,0,1,3.59c1,1.35,2.65,1.65,4.53.56,3-1.75,5.5-6.45,5.5-10.5,0-2.83-1.2-4.59-3-4.79a4.13,4.13,0,0,0-2.54.63C57.12,268.13,54.66,272.83,54.66,276.88Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.66,276.88a6,6,0,0,0,1,3.59c1,1.35,2.65,1.65,4.53.56,3-1.75,5.5-6.45,5.5-10.5,0-2.83-1.2-4.59-3-4.79a4.13,4.13,0,0,0-2.54.63C57.12,268.13,54.66,272.83,54.66,276.88Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.66,276.88a6,6,0,0,0,1,3.59,4.16,4.16,0,0,0,2.55-.63c3-1.75,5.49-6.46,5.49-10.51a6,6,0,0,0-1-3.59,4.13,4.13,0,0,0-2.54.63C57.12,268.13,54.66,272.83,54.66,276.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.91,271.17l.78,2.77,2-6.58A2.62,2.62,0,0,0,63.3,266Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.91,271.17l.78,2.77,2-6.58A2.62,2.62,0,0,0,63.3,266Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.89,273l-2,3.17,1.39,1.66a4.17,4.17,0,0,0,1.06-1.55Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.89,273l-2,3.17,1.39,1.66a4.17,4.17,0,0,0,1.06-1.55Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,279.21a4.21,4.21,0,0,0,.53,1.13l4.94-4.54-1.72-.68-.13.58-.5-.21h0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,279.21a4.21,4.21,0,0,0,.53,1.13l4.94-4.54-1.72-.68-.13.58-.5-.21h0Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.87,274.76l3.26.73h0l.31-.49.32.12.53-2.5-.39.22,0-.65-3.29,0A14.42,14.42,0,0,0,54.87,274.76Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.87,274.76l3.26.73h0l.31-.49.32.12.53-2.5-.39.22,0-.65-3.29,0A14.42,14.42,0,0,0,54.87,274.76Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.92,272.19l.5-.16-.13.59,2.14-1.24-1.88-4.61A8.86,8.86,0,0,0,58,268.26Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.92,272.19l.5-.16-.13.59,2.14-1.24-1.88-4.61A8.86,8.86,0,0,0,58,268.26Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.16,
    cy: 273.7,
    rx: 3.19,
    ry: 1.81,
    transform: "matrix(0.39, -0.92, 0.92, 0.39, -215.24, 221.89)",
    style: {
      fill: "#BA68C8"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "52.88 268.48 52.88 279.72 91.78 302.18 91.78 290.95 52.88 268.48"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.28,259.84v3L48,268.47l4.25-7.38a5.28,5.28,0,0,1,1.63-1.63L63.34,254l4.56-2.63a1.08,1.08,0,0,1,1.55.48l7.23,15.53a1.62,1.62,0,0,0,.1.18l0,.06a1.12,1.12,0,0,0,.28.25l0,0a1,1,0,0,0,.21.08,1.1,1.1,0,0,0,.31,0h.13l.14,0a1.07,1.07,0,0,0,.27-.12L112.62,248a3.44,3.44,0,0,0,1.39-1.75l7.56-24.93a3.49,3.49,0,0,1,1.38-1.74l10.17-5.88L137,211.5a1.2,1.2,0,0,1,1.63.44l4.27,7.39v-4.42a5.26,5.26,0,0,0-.6-2.23l-2.45-4.25a1.22,1.22,0,0,0-.2-.25l-.12-.11-.12-.07h0l0,0-9.69-5.6a1.22,1.22,0,0,0-1.2,0l-16.16,9.33a3.49,3.49,0,0,0-1.39,1.75l-7.54,24.92a3.47,3.47,0,0,1-1.38,1.75L74,256.27,70.4,248.5A1.1,1.1,0,0,0,70,248h0l-9.72-5.62a1.07,1.07,0,0,0-1.09,0l-17.39,10a4.32,4.32,0,0,0-1.51,1.69l-1.48,3.42A7,7,0,0,0,38.28,259.84Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.28,259.84v3L48,268.47l4.25-7.38a5.28,5.28,0,0,1,1.63-1.63L63.34,254l4.56-2.63a1.08,1.08,0,0,1,1.55.48l7.23,15.53a1.62,1.62,0,0,0,.1.18l0,.06a1.32,1.32,0,0,0,.28.25l0,0a1,1,0,0,0,.21.08,1.1,1.1,0,0,0,.31,0,.86.86,0,0,0,.27,0,1.07,1.07,0,0,0,.27-.12L112.62,248a3.44,3.44,0,0,0,1.39-1.75l7.56-24.93a3.49,3.49,0,0,1,1.38-1.74l10.17-5.88L137,211.5a1.2,1.2,0,0,1,1.63.44l4.27,7.39v-4.42a5.26,5.26,0,0,0-.6-2.23l-2.45-4.25a1.22,1.22,0,0,0-.2-.25l-.12-.11-.12-.07h0l0,0-9.69-5.6a1.22,1.22,0,0,0-1.2,0l-16.16,9.33a3.49,3.49,0,0,0-1.39,1.75l-7.54,24.92a3.47,3.47,0,0,1-1.38,1.75L74,256.27,70.4,248.5A1.1,1.1,0,0,0,70,248h0l-9.72-5.62a1.07,1.07,0,0,0-1.09,0l-17.39,10a4.32,4.32,0,0,0-1.51,1.69l-1.48,3.42A7,7,0,0,0,38.28,259.84Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,268.47l-9.73-5.62v-3a6,6,0,0,1,.13-1.12l11.42,6.59Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.76,257.54l1.48-3.41a3.85,3.85,0,0,1,.67-1l12.12,7a4.87,4.87,0,0,0-.77.95l-2.43,4.22-11.42-6.59A6.37,6.37,0,0,1,38.76,257.54Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.59,239.61a3.46,3.46,0,0,0,.76-1.23l7.54-24.92a3.28,3.28,0,0,1,.57-1l11.93,6.89-.44.26a3.49,3.49,0,0,0-1.38,1.74L114,246.21Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,246.26l7.56-24.93a3.49,3.49,0,0,1,1.38-1.74l14-8.09a1.19,1.19,0,0,1,1.63.44l4.27,7.39v-4.42a5.26,5.26,0,0,0-.6-2.23l-2.45-4.25a1.2,1.2,0,0,0-1.64-.44L122,217.33a3.45,3.45,0,0,0-1.39,1.74L113.07,244a3.49,3.49,0,0,1-1.38,1.74L79.17,264.52a1.08,1.08,0,0,1-1.55-.49L70.4,248.5a1.08,1.08,0,0,0-1.55-.49L51.47,258a4.2,4.2,0,0,0-1.51,1.7l-1.48,3.42a6.94,6.94,0,0,0-.47,2.3v3l4.25-7.38a5.42,5.42,0,0,1,1.63-1.64l14-8.08a1.07,1.07,0,0,1,1.54.48l7.24,15.54a1.08,1.08,0,0,0,1.54.48L112.63,248A3.47,3.47,0,0,0,114,246.26Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,265.46v3l4.25-7.38a5.28,5.28,0,0,1,1.63-1.63L63.34,254l4.56-2.63a1.08,1.08,0,0,1,1.55.48l7.23,15.53a1.62,1.62,0,0,0,.1.18l0,.06a1.12,1.12,0,0,0,.28.25l0,0a1,1,0,0,0,.21.08,1.1,1.1,0,0,0,.31,0h.13l.14,0a1.07,1.07,0,0,0,.27-.12L112.62,248a3.44,3.44,0,0,0,1.39-1.75l7.56-24.93a3.49,3.49,0,0,1,1.38-1.74l10.17-5.88L137,211.5a1.2,1.2,0,0,1,1.63.44l4.27,7.39v-4.42a5.26,5.26,0,0,0-.6-2.23l-2.45-4.25a1.22,1.22,0,0,0-.2-.25l-.12-.11-.13-.08,0,0a1.22,1.22,0,0,0-1.17,0L122,217.33a3.45,3.45,0,0,0-1.39,1.74L113.07,244a3.45,3.45,0,0,1-1.39,1.74L79.17,264.52a1.08,1.08,0,0,1-1.55-.49L74,256.27,70.4,248.5A1.1,1.1,0,0,0,70,248a1.08,1.08,0,0,0-1.1,0L51.47,258a4.2,4.2,0,0,0-1.51,1.7l-1.48,3.42A7,7,0,0,0,48,265.46Z",
    style: {
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.26 255.85 179.33 226.36 135.56 201.09 84.49 230.58 128.26 255.85",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.83 254.44 172.03 227.77 133.13 205.3 86.92 231.98 125.83 254.44",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.66 261.44 121.66 251.56 80.31 227.74 79.1 235.47 76.67 236.87 120.44 262.14 121.66 261.44",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.88,232.66h0a2.7,2.7,0,0,1,2.74.27l33.45,19.32A8.61,8.61,0,0,1,121,259v9.51l-28.5,23.84L50.33,251Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.88,232.66h0a2.7,2.7,0,0,1,2.74.27l33.45,19.32A8.61,8.61,0,0,1,121,259v9.51l-28.5,23.84L50.33,251Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.21,282.69l-1.41-7s9.71-6.57,16.53-11.44,11.34-8.42,9.65-11.13-9.28-8.19-22.9-17.06l28,16.17A8.61,8.61,0,0,1,121,259v7.56Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,274.91a4.62,4.62,0,0,1,.64,2.16v9l1.81,6.26L121,268.48V259a7.86,7.86,0,0,0-1.06-3.67Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.86,287v-9.88a6.29,6.29,0,0,0-2.89-5L52.81,251.19a2.91,2.91,0,0,0-1.46-.43c-1.21,0-2,1-2,2.45V264l1.12,5.87,42.71,24.65Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.86,287v-9.88a6.29,6.29,0,0,0-2.89-5L52.81,251.19a2.91,2.91,0,0,0-1.46-.43c-1.21,0-2,1-2,2.45V264l1.12,5.87,42.71,24.65Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.92,264V253.21c0-1.66,1.16-2.33,2.59-1.5l36.16,20.88a5.71,5.71,0,0,1,2.59,4.49V287l1.21,7.12L51.13,270.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.66,287.07v-10a5.17,5.17,0,0,0-2.29-4L52.21,252.23a1.78,1.78,0,0,0-.86-.27c-.75,0-.83.87-.83,1.25V263.9l1.28,6.77,40,23.07Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.66,287.07v-10a5.17,5.17,0,0,0-2.29-4L52.21,252.23a1.78,1.78,0,0,0-.86-.27c-.75,0-.83.87-.83,1.25V263.9l1.28,6.77,40,23.07Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50.52 263.9 90.66 287.07 91.77 293.74 51.8 270.67 50.52 263.9",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.32,269.71a.59.59,0,0,0-.26-.45l-.57-.33c-.14-.09-.25,0-.25.14l0,10.16,1.31,6.86,1.15.67-1.38-6.89Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.89,268.31a.57.57,0,0,0-.26-.45l-.57-.34c-.14-.08-.26,0-.26.15l0,10.16,1.31,6.86,1.15.66-1.38-6.88Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.46,266.9a.61.61,0,0,0-.26-.45l-.57-.33c-.14-.09-.26,0-.26.14l0,10.17,1.31,6.85,1.14.67-1.37-6.88Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71,265.5a.54.54,0,0,0-.25-.45l-.57-.34c-.14-.08-.26,0-.26.15l0,10.16,1.3,6.86,1.15.66L71,275.66Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.59,264.1a.56.56,0,0,0-.25-.45l-.57-.34c-.14-.08-.26,0-.26.15l0,10.16,1.31,6.86,1.15.66-1.37-6.88Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.16,262.69a.58.58,0,0,0-.26-.45l-.56-.33c-.15-.09-.26,0-.26.14l0,10.17,1.31,6.85,1.15.67-1.37-6.88Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.73,261.29a.56.56,0,0,0-.26-.45l-.57-.33c-.14-.09-.25,0-.25.14l0,10.17,1.31,6.85,1.15.67-1.37-6.89Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.35,255.17v5.51A1.42,1.42,0,0,0,53,261.8l4.77,2.76c.35.2.64,0,.64-.38v-5.5a1.45,1.45,0,0,0-.64-1.13L53,254.8C52.64,254.59,52.35,254.76,52.35,255.17Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.77,272.74v5.51a1.43,1.43,0,0,0,.65,1.12l4.76,2.75c.36.21.65,0,.65-.37v-5.51a1.43,1.43,0,0,0-.65-1.12l-4.76-2.75C83.06,272.16,82.77,272.33,82.77,272.74Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.9,244.61l9.72,5.62-4.26-7.39a1.19,1.19,0,0,0-1.63-.43Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.9,244.61l9.72,5.62-4.26-7.39a1.19,1.19,0,0,0-1.63-.43Z",
    style: {
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,282.1l3.62,7.76a1.07,1.07,0,0,0,.46.5l9.72,5.62h0a.85.85,0,0,0,.22.09,1.09,1.09,0,0,1-.68-.6L118.09,280a1.08,1.08,0,0,0-1.55-.49Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,282.1l3.62,7.76a1.07,1.07,0,0,0,.46.5l9.72,5.62h0a.85.85,0,0,0,.22.09,1.09,1.09,0,0,1-.68-.6L118.09,280a1.08,1.08,0,0,0-1.55-.49Z",
    style: {
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.38,300.24a1.7,1.7,0,0,0,.56-1.12c.09-.6.2-1.19.32-1.79a1.16,1.16,0,0,0-.06-.88l-.18-.1c-.16-.1-.18-.49,0-.94l1.13-3.26c.17-.49.48-.85.7-.81s.57-.3.8-.76.57-1.13.87-1.67a1.58,1.58,0,0,0,.24-1.2A1.24,1.24,0,0,1,92,286.6L94,284c.25-.33.53-.48.69-.39l.34.2a1,1,0,0,0,.54-.32c.39-.39.78-.76,1.19-1.11a1.72,1.72,0,0,0,.6-1.11,1.26,1.26,0,0,1,.61-1l2.26-1.31a.44.44,0,0,1,.46-.05l1.11.64c.28-.07.56-.13.83-.17a1.12,1.12,0,0,0,.81-.72.75.75,0,0,1,.76-.57l2,.37.12.05,9.73,5.62a.54.54,0,0,1,.2.59l2.41,1.39a.44.44,0,0,1,.16.17l1.14,2a1.09,1.09,0,0,1-.09,1.06,1.45,1.45,0,0,0-.19,1.17q.19.68.33,1.41l.8.47a.64.64,0,0,1,.21.56v3a1.33,1.33,0,0,1-.45,1.07,1.74,1.74,0,0,0-.55,1.12c-.08.6-.19,1.2-.32,1.8a1.21,1.21,0,0,0,.06.88l.17.09c.16.1.18.49,0,.94l-1.14,3.27c-.17.48-.47.84-.68.8s-.55.31-.77.78-.58,1.15-.89,1.7a1.54,1.54,0,0,0-.25,1.17c.12.21,0,.7-.31,1.09l-2,2.64c-.25.34-.53.49-.68.41l-.29-.17a1,1,0,0,0-.56.33c-.4.41-.81.79-1.23,1.15a1.71,1.71,0,0,0-.59,1.06,1.27,1.27,0,0,1-.61.93l-2.27,1.3a.48.48,0,0,1-.46.07l-1-.58c-.33.08-.65.14-1,.19a1.06,1.06,0,0,0-.79.67.73.73,0,0,1-.74.53l-2-.38-.14,0c-.19-.12-9.68-5.6-9.72-5.62a.52.52,0,0,1-.2-.58l-2.4-1.39a.43.43,0,0,1-.17-.18L88,309a1,1,0,0,1,.08-1,1.49,1.49,0,0,0,.18-1.16,14.3,14.3,0,0,1-.33-1.43v0l-.78-.45c-.13-.07-.21-.28-.21-.57v-3A1.33,1.33,0,0,1,87.38,300.24Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.65,310v-3a1.33,1.33,0,0,1,.45-1.07,1.7,1.7,0,0,0,.56-1.12c.09-.6.2-1.2.33-1.79s0-.92-.19-1-.25-.47-.09-1l1.14-3.26c.16-.49.48-.85.7-.81s.57-.3.79-.77.57-1.12.88-1.66a1.52,1.52,0,0,0,.23-1.2c-.13-.22,0-.72.3-1.11l2-2.64c.29-.39.63-.53.76-.31s.49.12.8-.2.79-.77,1.2-1.11a1.75,1.75,0,0,0,.59-1.11,1.27,1.27,0,0,1,.61-1l2.27-1.31c.33-.2.61-.08.61.27a.43.43,0,0,0,.6.42,7.52,7.52,0,0,1,1.19-.27,1.1,1.1,0,0,0,.8-.72.76.76,0,0,1,.76-.57l2,.37c.29.06.43.4.3.77a.8.8,0,0,0,.23.93,6.88,6.88,0,0,1,.88.65.53.53,0,0,0,.79-.14c.22-.3.54-.3.7,0l1.14,2a1.09,1.09,0,0,1-.09,1.06,1.45,1.45,0,0,0-.19,1.17q.19.68.33,1.41c.07.4.31.62.56.48s.45.1.45.55v3a1.33,1.33,0,0,1-.45,1.07,1.74,1.74,0,0,0-.55,1.12c-.08.6-.19,1.2-.32,1.8s0,.91.18,1,.24.46.08.95l-1.14,3.27c-.17.48-.47.84-.68.8s-.55.31-.77.78-.58,1.15-.89,1.7a1.54,1.54,0,0,0-.25,1.17c.12.21,0,.7-.31,1.09l-2,2.64c-.29.39-.62.54-.74.34s-.47-.09-.79.23-.81.79-1.23,1.15a1.71,1.71,0,0,0-.59,1.06,1.27,1.27,0,0,1-.61.93l-2.27,1.3c-.33.2-.61.1-.61-.22s-.27-.47-.6-.37a9.23,9.23,0,0,1-1.22.27,1.06,1.06,0,0,0-.79.67.73.73,0,0,1-.74.53l-2-.38a.52.52,0,0,1-.31-.73.77.77,0,0,0-.25-.89,5.68,5.68,0,0,1-.89-.68.51.51,0,0,0-.77.12c-.21.28-.52.28-.68,0l-1.14-2a1.05,1.05,0,0,1,.08-1,1.5,1.5,0,0,0,.18-1.16,12,12,0,0,1-.32-1.43c-.07-.4-.31-.63-.55-.48S96.65,310.4,96.65,310Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.79,279.53l8.57,5,0,0a.35.35,0,0,1,.14.32.43.43,0,0,0,.6.42l.38-.1a6.16,6.16,0,0,1,.81-.17.93.93,0,0,0,.5-.26l-9.72-5.62a.93.93,0,0,1-.5.26C102.34,279.41,102.07,279.47,101.79,279.53Z",
    style: {
      fill: "#263238"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1,281.92l9.73,5.61a1.43,1.43,0,0,0,.24-.69,1.06,1.06,0,0,1,.17-.53l-9.73-5.61a1,1,0,0,0-.17.53A1.51,1.51,0,0,1,97.1,281.92Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M95,283.77l9.33,5.4,0,0a.18.18,0,0,1,.08.07.22.22,0,0,0,.27.11,1,1,0,0,0,.54-.31c.39-.39.78-.76,1.19-1.11a2.16,2.16,0,0,0,.36-.43l-9.73-5.61a2.42,2.42,0,0,1-.36.42,15.36,15.36,0,0,0-1.19,1.11A1,1,0,0,1,95,283.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.56,291.44l9.73,5.62a.33.33,0,0,1,.26-.1c.22,0,.57-.3.79-.76s.57-1.13.88-1.67a1.52,1.52,0,0,0,.23-1.2.53.53,0,0,1,0-.29l-9.72-5.61a.42.42,0,0,0,0,.28,1.53,1.53,0,0,1-.24,1.2c-.31.54-.59,1.1-.87,1.66s-.57.82-.8.78A.33.33,0,0,0,89.56,291.44Z",
    style: {
      fill: "#263238"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M99.29,297.06l-9.73-5.62a.33.33,0,0,1,.26-.09.25.25,0,0,0,.12,0L99.67,297a.26.26,0,0,1-.12,0A.33.33,0,0,0,99.29,297.06Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M91.73,287.71a.42.42,0,0,1,0-.28l9.72,5.61a.53.53,0,0,0,0,.29.7.7,0,0,1,0,.42l-9.73-5.62A.78.78,0,0,0,91.73,287.71Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M87.08,300.61l9.74,5.61a.76.76,0,0,1,.28-.36,1.68,1.68,0,0,0,.56-1.12c.09-.6.2-1.19.33-1.79a1.11,1.11,0,0,0-.08-.89h0L97.8,302l-.09-.05-9.51-5.49a1.2,1.2,0,0,1,.07.88c-.13.6-.24,1.19-.33,1.79a1.7,1.7,0,0,1-.56,1.12A.89.89,0,0,0,87.08,300.61Z",
    style: {
      fill: "#263238"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M87.38,300.24a1,1,0,0,0,.33-.41l9.73,5.61a1,1,0,0,1-.34.42.76.76,0,0,0-.28.36l-9.74-5.61A.89.89,0,0,1,87.38,300.24Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M87.9,308.36,97.62,314a1,1,0,0,1,.17-.4A1.29,1.29,0,0,0,98,313a1.38,1.38,0,0,0,0-.61,12.45,12.45,0,0,1-.32-1.43h0c-.07-.4-.31-.61-.55-.48a.22.22,0,0,1-.27,0l-8.91-5.14h0c.09.5.2,1,.32,1.43a1.42,1.42,0,0,1-.18,1.16A1,1,0,0,0,87.9,308.36Z",
    style: {
      fill: "#263238"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M97.79,313.58a1,1,0,0,0-.17.4l-9.72-5.62a1,1,0,0,1,.16-.4,1.12,1.12,0,0,0,.2-.5L98,313.07A1.24,1.24,0,0,1,97.79,313.58Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M116.39,285.77a5.46,5.46,0,0,1,.88.66.54.54,0,0,0,.79-.15.42.42,0,0,1,.52-.19l0,0-2.35-1.36a.65.65,0,0,0,0,.13A.8.8,0,0,0,116.39,285.77Z",
    style: {
      fill: "#263238"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9,313.11h0l0,0,.14.08,9.46,5.47.06,0a.55.55,0,0,1-.15-.66.77.77,0,0,0-.25-.89,5.68,5.68,0,0,1-.89-.68.51.51,0,0,0-.77.12.41.41,0,0,1-.44.2l-.09-.05-7.31-4.22A.51.51,0,0,0,91.9,313.11Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M106.2,317.77l1,.58a.3.3,0,0,1-.13-.29c0-.31-.28-.47-.61-.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.94,313.51l.23.13,0,0A.19.19,0,0,0,112.94,313.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,291.87c.07.4.31.62.56.48a.21.21,0,0,1,.2,0l-.07,0-.11-.07Z",
    style: {
      fill: "#263238"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M103.11,279.11l9.72,5.62a1.17,1.17,0,0,0,.31-.47.85.85,0,0,1,.34-.44l-9.73-5.62a1,1,0,0,0-.34.45A1.26,1.26,0,0,1,103.11,279.11Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M90.84,305.1c0,4.9,1.63,8.36,4.21,9.84l1.74,1c-2.54-1.51-4.14-4.94-4.14-9.8,0-9,5.44-19.37,12.17-23.25,2.89-1.68,5.56-1.86,7.65-.81l-1.5-.86c-2.13-1.24-4.92-1.12-8,.64C96.29,285.73,90.84,296.15,90.84,305.1Z",
    style: {
      fill: "#37474f"
    }
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M92.65,306.14c0,4.86,1.6,8.3,4.14,9.81l1.17.67c-2.53-1.51-4.14-4.94-4.14-9.8,0-8.95,5.45-19.37,12.17-23.24,3-1.74,5.75-1.87,7.88-.69l-1.4-.81c-2.09-1-4.76-.86-7.65.81C98.09,286.77,92.65,297.18,92.65,306.14Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M103.75,278.2l9.73,5.62a.5.5,0,0,1,.42-.12l.81.15,1.15.22.08,0-.13-.08-9-5.2-.17-.1-.17-.1-.06,0-.09-.06-.06,0-.06,0-.06,0-2-.38A.53.53,0,0,0,103.75,278.2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.51,280.7l9.73,5.61a1.39,1.39,0,0,1,.43-.44l2.27-1.3a.46.46,0,0,1,.42-.07l-8.57-5-.73-.41-.26-.15-.13-.08a.5.5,0,0,0-.46.06L98,280.26A1.24,1.24,0,0,0,97.51,280.7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.69,287.43l9.72,5.61a1.78,1.78,0,0,1,.34-.82l2-2.64c.22-.29.47-.45.63-.41L95,283.77l-.34-.19c-.16-.1-.44.05-.68.38l-2,2.64A1.6,1.6,0,0,0,91.69,287.43Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,296.33l.06,0,.14.08,9.51,5.49a1.07,1.07,0,0,1,0-.91l1.14-3.27a1.56,1.56,0,0,1,.44-.7l-9.73-5.62a1.77,1.77,0,0,0-.44.71L88,295.42C87.84,295.84,87.85,296.22,88,296.33Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.93,301.31v3c0,.29.08.5.21.57l.78.46,8.91,5.14a.73.73,0,0,1-.17-.55v-3a1.6,1.6,0,0,1,.16-.7h0l-9.74-5.61A1.79,1.79,0,0,0,86.93,301.31Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,309l1.13,2a.43.43,0,0,0,.17.18l.53.31.2.11,1.67,1L99,316.75a.46.46,0,0,1-.15-.16l-1.14-2a1.05,1.05,0,0,1-.09-.64l-9.72-5.62A.92.92,0,0,0,88,309Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.16,305.26c0,4.89,3,7.14,6.64,5s6.65-7.81,6.65-12.7-3-7.14-6.65-5S102.16,300.37,102.16,305.26Zm1.15-.66c0-4.05,2.46-8.75,5.49-10.5s5.5.1,5.5,4.15-2.46,8.75-5.5,10.51S103.31,308.65,103.31,304.6Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.31,304.6a6,6,0,0,0,1,3.59c1,1.35,2.64,1.65,4.52.57,3-1.76,5.5-6.46,5.5-10.5,0-2.84-1.2-4.6-3-4.8a4.2,4.2,0,0,0-2.54.63C105.77,295.85,103.31,300.55,103.31,304.6Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.31,304.6a6,6,0,0,0,1,3.59c1,1.35,2.64,1.65,4.52.57,3-1.76,5.5-6.46,5.5-10.5,0-2.84-1.2-4.6-3-4.8a4.2,4.2,0,0,0-2.54.63C105.77,295.85,103.31,300.55,103.31,304.6Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.31,304.6a6,6,0,0,0,1,3.59,4.06,4.06,0,0,0,2.54-.63c3-1.75,5.5-6.46,5.5-10.5a6,6,0,0,0-1-3.6,4.2,4.2,0,0,0-2.54.63C105.77,295.85,103.31,300.55,103.31,304.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.55,298.9l.78,2.76,2-6.57a2.61,2.61,0,0,0-.38-1.33Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.55,298.9l.78,2.76,2-6.57a2.61,2.61,0,0,0-.38-1.33Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.53,300.72l-2,3.18,1.4,1.66a4.39,4.39,0,0,0,1.05-1.56Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.53,300.72l-2,3.18,1.4,1.66a4.39,4.39,0,0,0,1.05-1.56Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.65,306.93a4.08,4.08,0,0,0,.54,1.13l4.94-4.54-1.73-.67-.12.57-.5-.21h0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.65,306.93a4.08,4.08,0,0,0,.54,1.13l4.94-4.54-1.73-.67-.12.57-.5-.21h0Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.52,302.48l3.26.73h0l.3-.49.32.13.53-2.51-.39.23,0-.65-3.29,0A13.31,13.31,0,0,0,103.52,302.48Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.52,302.48l3.26.73h0l.3-.49.32.13.53-2.51-.39.23,0-.65-3.29,0A13.31,13.31,0,0,0,103.52,302.48Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.56,299.92l.5-.16-.13.58,2.14-1.24-1.88-4.61A9.61,9.61,0,0,0,106.6,296Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.56,299.92l.5-.16-.13.58,2.14-1.24-1.88-4.61A9.61,9.61,0,0,0,106.6,296Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.73,302.63c0,1.53.93,2.23,2.07,1.57a5,5,0,0,0,2.08-4c0-1.54-.93-2.24-2.08-1.58A5,5,0,0,0,106.73,302.63Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153,262.31a1.75,1.75,0,0,0,.56-1.13c.09-.59.2-1.19.33-1.79a1.17,1.17,0,0,0-.07-.87l-.18-.11c-.16-.1-.18-.49,0-.93l1.13-3.27c.17-.48.48-.84.7-.8s.57-.31.8-.77.57-1.12.87-1.67a1.51,1.51,0,0,0,.24-1.19,1.24,1.24,0,0,1,.29-1.11l2-2.64c.25-.33.53-.48.69-.39l.34.19a1,1,0,0,0,.54-.31c.39-.4.78-.77,1.19-1.12a1.72,1.72,0,0,0,.6-1.11,1.27,1.27,0,0,1,.61-1l2.26-1.31a.49.49,0,0,1,.46,0l1.11.64c.28-.07.56-.12.83-.16a1.15,1.15,0,0,0,.81-.73.76.76,0,0,1,.76-.57l2,.38a.26.26,0,0,1,.12,0l9.73,5.61a.54.54,0,0,1,.2.59l2.42,1.39a.5.5,0,0,1,.15.17l1.14,2a1.09,1.09,0,0,1-.09,1.06,1.45,1.45,0,0,0-.19,1.17,14.09,14.09,0,0,1,.33,1.42l.8.46a.66.66,0,0,1,.21.57v3a1.33,1.33,0,0,1-.45,1.07,1.74,1.74,0,0,0-.55,1.12c-.08.6-.19,1.2-.32,1.8a1.21,1.21,0,0,0,.06.88l.17.1c.16.09.18.49,0,.93l-1.14,3.27c-.16.49-.47.85-.68.81s-.55.31-.77.77-.58,1.15-.89,1.71a1.53,1.53,0,0,0-.25,1.17c.12.21,0,.69-.31,1.08l-2,2.65c-.25.33-.53.49-.68.4l-.29-.17a1,1,0,0,0-.56.34c-.4.4-.81.79-1.23,1.14a1.73,1.73,0,0,0-.59,1.07,1.25,1.25,0,0,1-.61.92l-2.27,1.31a.47.47,0,0,1-.46.06l-1-.58a9,9,0,0,1-1,.19,1.06,1.06,0,0,0-.79.68.72.72,0,0,1-.74.52l-2-.38a.34.34,0,0,1-.14,0l-9.72-5.61a.54.54,0,0,1-.2-.59l-2.4-1.38a.59.59,0,0,1-.17-.18l-1.13-2a1,1,0,0,1,.08-1,1.53,1.53,0,0,0,.18-1.17,14.3,14.3,0,0,1-.33-1.43h0l-.78-.46c-.13-.07-.21-.27-.21-.56v-3A1.33,1.33,0,0,1,153,262.31Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.31,272v-3a1.37,1.37,0,0,1,.45-1.08,1.7,1.7,0,0,0,.56-1.12c.09-.59.2-1.19.33-1.79s0-.92-.19-1-.25-.47-.09-.95l1.14-3.27c.17-.49.48-.84.7-.8s.57-.31.79-.77.57-1.12.88-1.67a1.5,1.5,0,0,0,.23-1.19c-.13-.22,0-.72.3-1.11l2-2.65c.29-.39.63-.53.76-.3s.49.12.81-.21.78-.76,1.19-1.11a1.75,1.75,0,0,0,.59-1.11,1.28,1.28,0,0,1,.61-1l2.27-1.31c.33-.19.61-.07.61.27a.43.43,0,0,0,.6.42,7.48,7.48,0,0,1,1.19-.26,1.14,1.14,0,0,0,.8-.73.76.76,0,0,1,.76-.57l2,.38c.29.05.43.4.3.77a.78.78,0,0,0,.23.92,6.12,6.12,0,0,1,.88.66.53.53,0,0,0,.79-.15c.22-.29.54-.3.7,0l1.14,2a1.09,1.09,0,0,1-.09,1.06,1.45,1.45,0,0,0-.19,1.17,14.09,14.09,0,0,1,.33,1.42c.07.4.31.62.56.47s.45.11.45.56v3a1.33,1.33,0,0,1-.45,1.07,1.74,1.74,0,0,0-.55,1.12c-.08.6-.19,1.2-.32,1.8s0,.92.18,1,.24.47.08.95l-1.14,3.27c-.16.49-.47.85-.68.81s-.55.31-.77.77-.58,1.15-.89,1.71a1.53,1.53,0,0,0-.25,1.17c.12.21,0,.69-.31,1.08l-2,2.65c-.29.39-.62.54-.74.33s-.47-.09-.79.24-.81.79-1.23,1.14a1.73,1.73,0,0,0-.59,1.07,1.25,1.25,0,0,1-.61.92l-2.27,1.31c-.33.19-.61.09-.61-.22s-.27-.47-.6-.38a6.86,6.86,0,0,1-1.22.27,1.06,1.06,0,0,0-.79.68.72.72,0,0,1-.74.52l-2-.38c-.29,0-.43-.38-.31-.73a.76.76,0,0,0-.25-.88,7.23,7.23,0,0,1-.89-.68.5.5,0,0,0-.77.11.37.37,0,0,1-.68,0l-1.14-2a1.05,1.05,0,0,1,.08-1,1.48,1.48,0,0,0,.18-1.17,12,12,0,0,1-.32-1.43c-.07-.4-.31-.62-.55-.48S162.31,272.46,162.31,272Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.45,241.6l8.57,5,0,0a.36.36,0,0,1,.14.32.43.43,0,0,0,.6.42l.38-.1a6.43,6.43,0,0,1,.81-.16,1,1,0,0,0,.5-.26l-9.72-5.63a1,1,0,0,1-.5.27C168,241.48,167.73,241.53,167.45,241.6Z",
    style: {
      fill: "#263238"
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M162.76,244l9.73,5.62a1.51,1.51,0,0,0,.24-.69,1,1,0,0,1,.17-.53l-9.73-5.62a1,1,0,0,0-.17.53A1.43,1.43,0,0,1,162.76,244Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M160.67,245.83l9.33,5.41.05,0a.15.15,0,0,1,.08.08.23.23,0,0,0,.27.11,1,1,0,0,0,.54-.31c.39-.4.78-.77,1.19-1.12a1.85,1.85,0,0,0,.36-.42L162.76,244a1.85,1.85,0,0,1-.36.42c-.41.35-.8.72-1.19,1.11A1,1,0,0,1,160.67,245.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.22,253.51l9.73,5.61a.29.29,0,0,1,.26-.09c.22,0,.57-.31.79-.77s.57-1.13.88-1.67a1.5,1.5,0,0,0,.23-1.19.53.53,0,0,1,0-.29l-9.72-5.62a.46.46,0,0,0,0,.29,1.51,1.51,0,0,1-.24,1.19c-.31.54-.59,1.1-.87,1.67s-.57.81-.8.77A.31.31,0,0,0,155.22,253.51Z",
    style: {
      fill: "#263238"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M165,259.12l-9.73-5.61a.31.31,0,0,1,.26-.1.25.25,0,0,0,.12,0l9.73,5.61a.27.27,0,0,1-.12,0A.29.29,0,0,0,165,259.12Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M157.39,249.78a.46.46,0,0,1,0-.29l9.72,5.62a.53.53,0,0,0,0,.29.65.65,0,0,1,0,.41l-9.73-5.62A.75.75,0,0,0,157.39,249.78Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M152.74,262.67l9.74,5.62a.79.79,0,0,1,.28-.37,1.66,1.66,0,0,0,.56-1.12c.09-.6.2-1.19.33-1.79a1.11,1.11,0,0,0-.08-.89h0l-.11-.05-.09-.06-9.51-5.48a1.17,1.17,0,0,1,.07.87c-.13.6-.24,1.2-.33,1.79a1.75,1.75,0,0,1-.56,1.13A.79.79,0,0,0,152.74,262.67Z",
    style: {
      fill: "#263238"
    }
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M153,262.31a1.06,1.06,0,0,0,.33-.42l9.73,5.62a1,1,0,0,1-.34.41.79.79,0,0,0-.28.37l-9.74-5.62A.79.79,0,0,1,153,262.31Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M153.56,270.42l9.73,5.63a1,1,0,0,1,.16-.4,1.49,1.49,0,0,0,.18-1.17,11.57,11.57,0,0,1-.32-1.43h0c-.07-.39-.31-.61-.55-.47a.26.26,0,0,1-.27,0l-8.91-5.15h0c.09.5.2,1,.32,1.43a1.41,1.41,0,0,1-.18,1.16A1.16,1.16,0,0,0,153.56,270.42Z",
    style: {
      fill: "#263238"
    }
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M163.45,275.65a1,1,0,0,0-.16.4l-9.73-5.63a1.16,1.16,0,0,1,.16-.4,1.12,1.12,0,0,0,.2-.5l9.73,5.62A1.36,1.36,0,0,1,163.45,275.65Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M182.05,247.83a6.12,6.12,0,0,1,.88.66.53.53,0,0,0,.79-.15.43.43,0,0,1,.52-.19l0,0-2.35-1.36a.57.57,0,0,0,0,.14A.79.79,0,0,0,182.05,247.83Z",
    style: {
      fill: "#263238"
    }
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M157.56,275.17h0l.14.08,9.46,5.47.06,0a.56.56,0,0,1-.15-.67.75.75,0,0,0-.25-.88,6.36,6.36,0,0,1-.89-.68.5.5,0,0,0-.77.11.41.41,0,0,1-.44.2l-.09-.05-7.31-4.22A.51.51,0,0,0,157.56,275.17Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M171.86,279.83l1,.58a.29.29,0,0,1-.13-.28c0-.32-.28-.47-.61-.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.6,275.57l.23.14,0,0A.19.19,0,0,0,178.6,275.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.61,253.94c.07.4.31.61.56.47a.25.25,0,0,1,.2,0l-.07,0-.11-.06Z",
    style: {
      fill: "#263238"
    }
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M168.77,241.17l9.72,5.63a1.17,1.17,0,0,0,.31-.47.92.92,0,0,1,.34-.45l-9.73-5.62a1,1,0,0,0-.34.45A1.12,1.12,0,0,1,168.77,241.17Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M156.5,267.17c0,4.9,1.63,8.35,4.21,9.84l1.74,1c-2.54-1.51-4.14-4.95-4.14-9.81,0-8.95,5.44-19.37,12.17-23.24,2.89-1.68,5.56-1.86,7.65-.81l-1.5-.86c-2.13-1.24-4.92-1.13-8,.63C162,247.8,156.5,258.21,156.5,267.17Z",
    style: {
      fill: "#37474f"
    }
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M158.31,268.2c0,4.87,1.6,8.3,4.14,9.81l1.17.67c-2.53-1.5-4.14-4.94-4.14-9.79,0-9,5.45-19.37,12.17-23.25,3-1.74,5.75-1.87,7.88-.68l-1.4-.81c-2.09-1.05-4.76-.87-7.65.81C163.75,248.84,158.31,259.25,158.31,268.2Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M169.41,240.26l9.73,5.62a.57.57,0,0,1,.42-.12l.81.16,1.15.22.08,0-.13-.08-9-5.2-.17-.1-.17-.09-.06,0-.09-.05-.06,0-.06,0-.06,0-2-.38A.53.53,0,0,0,169.41,240.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.17,242.76l9.73,5.62a1.29,1.29,0,0,1,.43-.44l2.27-1.31a.49.49,0,0,1,.42-.07l-8.57-5-.73-.41-.26-.15-.13-.08a.49.49,0,0,0-.46,0l-2.26,1.31A1.42,1.42,0,0,0,163.17,242.76Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.35,249.49l9.72,5.62a1.81,1.81,0,0,1,.34-.83l2-2.64c.22-.29.47-.44.63-.4l-9.33-5.41-.34-.19c-.16-.1-.44.05-.68.38l-2,2.65A1.54,1.54,0,0,0,157.35,249.49Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.66,258.4l.06,0,.14.09,9.51,5.48a1,1,0,0,1,0-.9l1.14-3.27a1.55,1.55,0,0,1,.44-.71l-9.73-5.61a1.65,1.65,0,0,0-.44.7l-1.13,3.27C153.5,257.9,153.51,258.28,153.66,258.4Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.59,263.38v3c0,.29.08.49.21.56l.78.46,8.91,5.15a.75.75,0,0,1-.17-.55v-3a1.67,1.67,0,0,1,.16-.7h0l-9.74-5.62A1.84,1.84,0,0,0,152.59,263.38Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.65,271.07l1.13,2a.59.59,0,0,0,.17.18l.53.3.2.12,1.67,1,7.31,4.22a.39.39,0,0,1-.15-.16l-1.14-2a1,1,0,0,1-.08-.64l-9.73-5.63A1,1,0,0,0,153.65,271.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.82,267.33c0,4.89,3,7.14,6.65,5s6.64-7.8,6.64-12.7-3-7.14-6.64-5S167.82,262.43,167.82,267.33Zm1.15-.67c0-4,2.46-8.75,5.5-10.5s5.49.11,5.49,4.16-2.46,8.75-5.49,10.5S169,270.71,169,266.66Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169,266.67a6.06,6.06,0,0,0,1,3.59c1,1.34,2.64,1.64,4.52.56,3-1.75,5.5-6.45,5.5-10.5,0-2.83-1.2-4.59-3-4.8a4.14,4.14,0,0,0-2.54.64C171.43,257.91,169,262.62,169,266.67Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169,266.67a6.06,6.06,0,0,0,1,3.59c1,1.34,2.64,1.64,4.52.56,3-1.75,5.5-6.45,5.5-10.5,0-2.83-1.2-4.59-3-4.8a4.14,4.14,0,0,0-2.54.64C171.43,257.91,169,262.62,169,266.67Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169,266.67a6.06,6.06,0,0,0,1,3.59,4.14,4.14,0,0,0,2.54-.64c3-1.75,5.5-6.45,5.5-10.5a6,6,0,0,0-1-3.6,4.14,4.14,0,0,0-2.54.64C171.43,257.91,169,262.62,169,266.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.21,261l.78,2.76,2-6.57a2.61,2.61,0,0,0-.38-1.33Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.21,261l.78,2.76,2-6.57a2.61,2.61,0,0,0-.38-1.33Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.19,262.79,174.14,266l1.4,1.66a4.35,4.35,0,0,0,1.05-1.55Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.19,262.79,174.14,266l1.4,1.66a4.35,4.35,0,0,0,1.05-1.55Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.31,269a4.15,4.15,0,0,0,.54,1.14l4.94-4.54-1.73-.68-.12.58-.5-.21h0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.31,269a4.15,4.15,0,0,0,.54,1.14l4.94-4.54-1.73-.68-.12.58-.5-.21h0Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.18,264.55l3.26.73h0l.3-.49.32.12.53-2.51-.39.23,0-.65-3.3,0A14.15,14.15,0,0,0,169.18,264.55Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.18,264.55l3.26.73h0l.3-.49.32.12.53-2.51-.39.23,0-.65-3.3,0A14.15,14.15,0,0,0,169.18,264.55Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.23,262l.49-.16-.13.58,2.14-1.24-1.88-4.61a9.61,9.61,0,0,0-1.59,1.49Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.23,262l.49-.16-.13.58,2.14-1.24-1.88-4.61a9.61,9.61,0,0,0-1.59,1.49Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.39,264.69c0,1.53.93,2.24,2.08,1.57a5,5,0,0,0,2.07-4c0-1.53-.93-2.24-2.07-1.57A5,5,0,0,0,172.39,264.69Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.93,287.93v3l9.72,5.62,4.25-7.38a5.31,5.31,0,0,1,1.63-1.64L112,282.1l4.56-2.64a1.08,1.08,0,0,1,1.55.49l7.24,15.53a1,1,0,0,0,.1.17.23.23,0,0,0,0,.07.78.78,0,0,0,.27.24l0,0a.78.78,0,0,0,.21.09,1.1,1.1,0,0,0,.31,0h.14l.13,0a1,1,0,0,0,.27-.11l29.54-17.06a3.44,3.44,0,0,0,1.39-1.75l7.56-24.93a3.49,3.49,0,0,1,1.38-1.74l10.17-5.88,3.83-2.2a1.19,1.19,0,0,1,1.63.43l4.26,7.39v-4.42a5.4,5.4,0,0,0-.59-2.23l-2.45-4.25a1.22,1.22,0,0,0-.2-.25l-.12-.1-.12-.08h0l0,0-9.68-5.59a1.2,1.2,0,0,0-1.2,0l-16.16,9.34a3.37,3.37,0,0,0-1.39,1.74l-7.54,24.93a3.49,3.49,0,0,1-1.38,1.74l-23.09,13.33L119,276.59a1.11,1.11,0,0,0-.44-.49h0l-9.73-5.61a1.07,1.07,0,0,0-1.09,0l-17.39,10a4.28,4.28,0,0,0-1.51,1.7l-1.47,3.42A6.7,6.7,0,0,0,86.93,287.93Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.93,287.93v3l9.72,5.62,4.25-7.38a5.31,5.31,0,0,1,1.63-1.64L112,282.1l4.56-2.64a1.08,1.08,0,0,1,1.55.49l7.24,15.53a1,1,0,0,0,.1.17.23.23,0,0,0,0,.07.88.88,0,0,0,.27.24l0,0a.78.78,0,0,0,.21.09,1.1,1.1,0,0,0,.31,0,.88.88,0,0,0,.27,0,1,1,0,0,0,.27-.11l29.54-17.06a3.44,3.44,0,0,0,1.39-1.75l7.56-24.93a3.49,3.49,0,0,1,1.38-1.74l10.17-5.88,3.83-2.2a1.19,1.19,0,0,1,1.63.43l4.26,7.39v-4.42a5.4,5.4,0,0,0-.59-2.23l-2.45-4.25a1.22,1.22,0,0,0-.2-.25l-.12-.1-.12-.08h0l0,0-9.68-5.59a1.2,1.2,0,0,0-1.2,0l-16.16,9.34a3.37,3.37,0,0,0-1.39,1.74l-7.54,24.93a3.49,3.49,0,0,1-1.38,1.74l-23.09,13.33L119,276.59a1.11,1.11,0,0,0-.44-.49h0l-9.73-5.61a1.07,1.07,0,0,0-1.09,0l-17.39,10a4.28,4.28,0,0,0-1.51,1.7l-1.47,3.42A6.7,6.7,0,0,0,86.93,287.93Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.65,296.56,86.93,291v-3a6.12,6.12,0,0,1,.13-1.12l11.41,6.59Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4,285.64l1.48-3.42a3.89,3.89,0,0,1,.67-1l12.12,7a4.87,4.87,0,0,0-.77.95l-2.43,4.22-11.41-6.59A6.06,6.06,0,0,1,87.4,285.64Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.37,270.51a3.3,3.3,0,0,0,.76-1.23l7.54-24.92a3.13,3.13,0,0,1,.57-1l11.93,6.88-.44.26a3.56,3.56,0,0,0-1.39,1.74l-7.53,24.89Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.79,277.17l7.55-24.94a3.56,3.56,0,0,1,1.39-1.74l14-8.08a1.2,1.2,0,0,1,1.64.43l4.27,7.39v-4.42a5.26,5.26,0,0,0-.6-2.23l-2.45-4.25a1.19,1.19,0,0,0-1.64-.43l-16.16,9.33a3.45,3.45,0,0,0-1.39,1.74l-7.54,24.93a3.51,3.51,0,0,1-1.38,1.75l-27.66,16a1.07,1.07,0,0,1-1.54-.48L119,276.59a1.08,1.08,0,0,0-1.54-.49l-17.38,10a4.27,4.27,0,0,0-1.52,1.69l-1.48,3.42a7,7,0,0,0-.47,2.3v3l4.25-7.38a5.21,5.21,0,0,1,1.64-1.63l14-8.09a1.08,1.08,0,0,1,1.55.49l7.23,15.53a1.08,1.08,0,0,0,1.55.49l29.54-17.06A3.49,3.49,0,0,0,157.79,277.17Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.65,293.55v3l4.25-7.38a5.31,5.31,0,0,1,1.63-1.64L112,282.1l4.56-2.64a1.08,1.08,0,0,1,1.55.49l7.24,15.53a1,1,0,0,0,.1.17.23.23,0,0,0,0,.07.78.78,0,0,0,.27.24l0,0a.78.78,0,0,0,.21.09,1.1,1.1,0,0,0,.31,0h.14l.13,0a1,1,0,0,0,.27-.11l29.54-17.06a3.44,3.44,0,0,0,1.39-1.75l7.56-24.93a3.49,3.49,0,0,1,1.38-1.74l10.17-5.88,3.83-2.2a1.19,1.19,0,0,1,1.63.43l4.26,7.39v-4.42a5.4,5.4,0,0,0-.59-2.23l-2.45-4.25a1.22,1.22,0,0,0-.2-.25l-.12-.1-.13-.09,0,0a1.2,1.2,0,0,0-1.16,0l-16.16,9.33a3.45,3.45,0,0,0-1.39,1.74l-7.54,24.93a3.46,3.46,0,0,1-1.39,1.74l-27.65,16a1.08,1.08,0,0,1-1.54-.5l-3.61-7.76L119,276.59a1.11,1.11,0,0,0-.44-.49,1.08,1.08,0,0,0-1.11,0l-17.37,10a4.19,4.19,0,0,0-1.52,1.69l-1.48,3.42A7,7,0,0,0,96.65,293.55Z",
    style: {
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.34,276.59v2.81l15.44-8.91a1.07,1.07,0,0,1,1.09,0l9.73,5.61h0a1.11,1.11,0,0,1,.44.49l5.67,12.19,25.47-14.69a3.49,3.49,0,0,0,1.38-1.74l7.54-24.93a3.44,3.44,0,0,1,1.39-1.75l16.6-9.59a1.18,1.18,0,0,1,1.19,0l1.05.61V226.36l-51.07,29.49-4.17-5.69v8.09Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.34,276.59v2.81l15.44-8.91a1.07,1.07,0,0,1,1.09,0l9.73,5.61h0a1.11,1.11,0,0,1,.44.49l5.67,12.19,25.47-14.69a3.49,3.49,0,0,0,1.38-1.74l7.54-24.93a3.44,3.44,0,0,1,1.39-1.75l16.6-9.59a1.18,1.18,0,0,1,1.19,0l1.05.61V226.36l-51.07,29.49-4.17-5.69v8.09Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.15 245.95 150.15 272.62 148.93 246.65 150.15 245.95",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.29,252.87a.61.61,0,0,0-.3.52v1.05c0,.78,1.16.74,2.59-.09l2.11-1.22c1.43-.82,2.59-2.12,2.59-2.9v-.89a.3.3,0,0,0-.45-.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.18,276.59a5.74,5.74,0,0,1,2.58-4.47,1.84,1.84,0,0,1,1.81-.18h0l23.21,13.4-3.65,6.31L55.94,278.26h0A1.85,1.85,0,0,1,55.18,276.59Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.18,276.59a5.74,5.74,0,0,1,2.58-4.47,1.84,1.84,0,0,1,1.81-.18h0l23.21,13.4-3.65,6.31L55.94,278.26h0A1.85,1.85,0,0,1,55.18,276.59Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,291.48c-1.42.82-2.58.15-2.58-1.49A5.71,5.71,0,0,1,81,285.52c1.43-.82,2.58-.16,2.58,1.49A5.71,5.71,0,0,1,81,291.48Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,291.48c-1.42.82-2.58.15-2.58-1.49A5.71,5.71,0,0,1,81,285.52c1.43-.82,2.58-.16,2.58,1.49A5.71,5.71,0,0,1,81,291.48Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.15,272.6v5.62a2.85,2.85,0,0,0,1.29,2.24l36.32,21a6.67,6.67,0,0,0,2.79.75h8.23v-5.62l-4.86-2.8H83.55a6.67,6.67,0,0,1-2.79-.75L49.31,274.85A2.79,2.79,0,0,1,48,272.7v-1.41l-4.86-2.81v4.12ZM48,276.91Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.06,293.52a6.13,6.13,0,0,0,1.49.24h3.37l4.86,2.8v5.62H83.55a5.68,5.68,0,0,1-1.49-.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.55,293.76a6.67,6.67,0,0,1-2.79-.75L49.31,274.85A2.79,2.79,0,0,1,48,272.7v-1.41l-4.86-2.81v4.12a2.89,2.89,0,0,0,1.29,2.25l36.32,21a6.66,6.66,0,0,0,2.79.74h8.23l-4.86-2.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.05,180.77a4.08,4.08,0,0,1,6.1,3.12l2,19.43h0a.59.59,0,0,1-.35.51,1.89,1.89,0,0,1-1.7,0,.59.59,0,0,1-.34-.46h0l-2-19.24a1.69,1.69,0,0,0-2.53-1.29l-20.45,11.8-1.2-2.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.43,194l20.68-11.94a2.33,2.33,0,0,1,3.49,1.77L134.77,204a1.72,1.72,0,0,1-.69-.18.59.59,0,0,1-.34-.46h0l-2-19.24a1.69,1.69,0,0,0-2.53-1.29l-20.45,11.8Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.17,216.54l-34-19.66h0a7.89,7.89,0,0,0-3.94,6.31l-.93,10.54,34.05,19.65,4.86-2.8Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.17,220.57l-36.78-21.06a7.94,7.94,0,0,1,2.74-2.63l34,19.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.17,230.58v-14h0a7.9,7.9,0,0,0-3.94,6.31l-.92,10.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.23 222.84 162.31 233.38 154.24 238.04 127.48 222.6 129.19 203.19 163.23 222.84",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.48 222.6 108.81 233.38 135.56 248.83 154.24 238.04 127.48 222.6",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.57,203.69a4.09,4.09,0,0,1,6.11,3.12l2,19.43h0a.57.57,0,0,1-.34.51,1.89,1.89,0,0,1-1.7,0,.61.61,0,0,1-.35-.46h0l-2-19.23a1.7,1.7,0,0,0-2.53-1.3l-20.46,11.81-1.2-2.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.57,203.69a4.09,4.09,0,0,1,6.11,3.12l2,19.43h0a.57.57,0,0,1-.34.51,1.89,1.89,0,0,1-1.7,0,.61.61,0,0,1-.35-.46h0l-2-19.23a1.7,1.7,0,0,0-2.53-1.3l-20.46,11.81-1.2-2.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.57,203.69a4.09,4.09,0,0,1,6.11,3.12l2,19.43h0a.57.57,0,0,1-.34.51,1.89,1.89,0,0,1-1.7,0,.61.61,0,0,1-.35-.46h0l-2-19.23a1.7,1.7,0,0,0-2.53-1.3l-20.46,11.81-1.2-2.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.59 193.37 107.59 192.58 108.95 191.79 150.95 216.04 148.93 217.24 107.59 193.37",
    style: {
      fill: "#455a64"
    }
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M148.93,216.46v.78l-41.34-23.87v-.78Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M148.93,216.45,168.64,205a2.33,2.33,0,0,1,3.48,1.77l2.18,20.17a1.68,1.68,0,0,1-.69-.19.61.61,0,0,1-.35-.46h0l-2-19.23a1.7,1.7,0,0,0-2.53-1.3l-19.84,11.48Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.93 243.91 147.71 243.21 147.71 216.53 148.93 217.24 148.93 243.91",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.93 243.91 147.71 243.21 147.71 216.53 148.93 217.24 148.93 243.91",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.93 217.24 150.15 216.53 150.15 243.21 148.93 243.91 148.93 217.24",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.93 217.24 150.15 216.53 150.15 243.21 148.93 243.91 148.93 217.24",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.81 194.07 108.87 217.97 107.65 217.27 107.59 193.37 108.81 194.07",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.81 194.07 108.87 217.97 107.65 217.27 107.59 193.37 108.81 194.07",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.87 217.97 110.08 217.27 110.02 194.77 108.81 194.07 108.87 217.97",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.87 217.97 110.08 217.27 110.02 194.77 108.81 194.07 108.87 217.97",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,216.17h0a1.17,1.17,0,0,1,1.16.1l11,6.35a3.51,3.51,0,0,1,1.56,2.58l1,21.66,1.65.95h0l2.64-1.53a1,1,0,0,0,.4-1l-1-22.81a3.46,3.46,0,0,0-1.57-2.58l-11-6.35a1.18,1.18,0,0,0-1.18-.08h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.58,236.41l18.13,10.45-1-21.66a3.46,3.46,0,0,0-1.57-2.58l-11-6.35a1.09,1.09,0,0,0-1.74.84Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.93,221.05l-4.66,2.69a3.25,3.25,0,0,0-1.09-1.12l-11-6.35a1.17,1.17,0,0,0-1.16-.1h0l4.64-2.67h0a1.15,1.15,0,0,1,1.18.08l11,6.35A3.17,3.17,0,0,1,123.93,221.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.58,236.54a4.07,4.07,0,0,0,.69,2l10.3,5.93a1.14,1.14,0,0,0,.86-1.16,156.46,156.46,0,0,0,0-16.75,4.21,4.21,0,0,0-1.5-2.76,34.23,34.23,0,0,0-6.4-3.7,1.47,1.47,0,0,0-2.06,1A56.7,56.7,0,0,0,105.58,236.54Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.31,243.83a1.59,1.59,0,0,0,.12-.52,159.13,159.13,0,0,0,0-16.75A3.89,3.89,0,0,0,117,225c-.61-.86-.83,6.44-.82,10.9s.06,8.86.79,8.34a.27.27,0,0,0,.08-.07A2,2,0,0,0,117.31,243.83Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M106.61,236.17l.35.23.92.59c.76.5,1.78,1.14,2.82,1.73s2.11,1.16,2.92,1.56l1,.5a3.79,3.79,0,0,1,.37.19l-.41-.09c-.26-.06-.63-.15-1.07-.29s-.94-.33-1.47-.56c-.25-.12-.53-.23-.8-.38s-.53-.28-.8-.43a17.08,17.08,0,0,1-1.51-1,14.29,14.29,0,0,1-1.23-1c-.34-.31-.6-.59-.79-.78Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M106.61,233.29s.13.07.35.22l.92.6c.76.5,1.78,1.14,2.82,1.73s2.11,1.15,2.92,1.56c.4.2.74.38,1,.49l.37.19-.41-.08c-.26-.07-.63-.15-1.07-.3a15.53,15.53,0,0,1-1.47-.55c-.25-.13-.53-.24-.8-.38l-.8-.43c-.53-.32-1-.64-1.51-1a14.26,14.26,0,0,1-1.23-1c-.34-.3-.6-.58-.79-.77Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M107.2,230.9a3.71,3.71,0,0,1,.33.21c.21.14.51.31.86.54.7.45,1.64,1,2.61,1.55s2,1,2.72,1.37l.91.45.34.18-.38-.07c-.24-.06-.58-.13-1-.25s-.87-.28-1.37-.47c-.24-.1-.5-.2-.75-.32l-.75-.38c-.25-.14-.5-.28-.73-.43s-.47-.31-.69-.46a11.52,11.52,0,0,1-1.12-.91,10.1,10.1,0,0,1-.73-.72Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M107.44,228.21l.32.2.83.52c.68.44,1.59,1,2.53,1.49s1.91.94,2.64,1.29l.88.43.33.18-.37-.07c-.23-.06-.56-.12-1-.23s-.84-.26-1.32-.44a7.49,7.49,0,0,1-.73-.3c-.25-.11-.49-.23-.74-.36s-.48-.26-.71-.41-.45-.29-.66-.43a12.5,12.5,0,0,1-1.09-.89c-.3-.27-.54-.53-.7-.7Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M107.85,225.64l.31.19.78.49c.64.4,1.49.93,2.38,1.37s1.82.84,2.51,1.17,1.14.57,1.14.57a12.3,12.3,0,0,1-1.25-.26,13.46,13.46,0,0,1-2.66-1c-.22-.12-.45-.24-.67-.38a6.81,6.81,0,0,1-.63-.41,10.67,10.67,0,0,1-1-.83A9,9,0,0,1,107.85,225.64Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M108.81,223.17l1,.58c.56.35,1.31.8,2.08,1.19s1.56.78,2.15,1.08,1,.53,1,.53a8.55,8.55,0,0,1-1.1-.22,11.22,11.22,0,0,1-2.3-.88l-.58-.33c-.2-.12-.37-.25-.55-.37a9,9,0,0,1-.88-.74A6.43,6.43,0,0,1,108.81,223.17Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M129.05,229.47h0a1.17,1.17,0,0,1,1.16.1l11,6.35a3.51,3.51,0,0,1,1.56,2.58l.27,6,4.66-2.7-.27-6a3.46,3.46,0,0,0-1.57-2.58l-11-6.35a1.2,1.2,0,0,0-1.19-.08h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.71,249l.2.08,2.72,3.72,14.42-8.32-.27-6a3.48,3.48,0,0,0-1.56-2.58l-11-6.35a1.09,1.09,0,0,0-1.74.84Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147,234.35,142.3,237a3.32,3.32,0,0,0-1.08-1.12l-11-6.35a1.17,1.17,0,0,0-1.16-.1h0l4.64-2.67h0a1.17,1.17,0,0,1,1.19.08l11,6.35A3.25,3.25,0,0,1,147,234.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.62,249.85a4,4,0,0,0,1,2.4l9.6-5.54,1.48-.85c0-2.13-.07-4.14-.2-6,0-.12,0-.24,0-.37s-.06-.25-.1-.37h0c-.05-.13-.09-.26-.15-.39h0c0-.11-.1-.21-.15-.32l0-.06h0a3.75,3.75,0,0,0-1-1.24,34.23,34.23,0,0,0-6.4-3.7,1.48,1.48,0,0,0-2.06,1A56.43,56.43,0,0,0,128.62,249.85Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.23,246.71l1.48-.85c0-2.13-.07-4.14-.2-6,0-.12,0-.24,0-.37s-.06-.25-.1-.37h0c-.05-.13-.09-.26-.15-.39h0c0-.11-.1-.21-.15-.32l0-.06h0C139.53,237.67,139.29,242.5,139.23,246.71Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M129.64,249.48s.12.13.28.3.45.47.8.78.47.41.75.63l.45-.26c-.37-.22-.7-.44-1-.63s-.71-.45-.92-.6A2.29,2.29,0,0,0,129.64,249.48Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M129.64,246.59l.28.31c.19.19.45.47.8.77a14,14,0,0,0,1.22,1c.46.34,1,.66,1.51,1l.36.2.57-.33-.65-.37c-1-.59-2-1.23-2.81-1.73-.38-.25-.71-.45-.92-.6Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M130.24,244.2a3.33,3.33,0,0,0,.25.29c.17.18.42.44.73.72a12.87,12.87,0,0,0,1.12.91c.23.15.44.32.69.46s.48.29.72.43.51.26.76.37.51.23.75.33c.5.2,1,.35,1.37.47h0L137,248l-.26-.13c-.75-.36-1.75-.84-2.72-1.37s-1.91-1.09-2.61-1.55c-.35-.23-.65-.4-.85-.54Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M130.48,241.51l.32.2.82.52c.68.44,1.59,1,2.53,1.49s1.91.94,2.64,1.29l.88.43.34.18-.37-.07c-.24-.06-.57-.12-1-.23s-.85-.26-1.33-.44a7.49,7.49,0,0,1-.73-.3c-.25-.11-.49-.23-.74-.36s-.48-.26-.71-.41-.45-.29-.66-.43a12.5,12.5,0,0,1-1.09-.89c-.3-.27-.53-.53-.7-.7A3.24,3.24,0,0,1,130.48,241.51Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M130.89,238.94l.3.19.78.49a25.38,25.38,0,0,0,2.38,1.37c.89.45,1.82.84,2.51,1.17s1.15.57,1.15.57a12.12,12.12,0,0,1-1.26-.26,13.17,13.17,0,0,1-2.65-1c-.23-.12-.46-.24-.68-.37s-.43-.28-.63-.42a10.67,10.67,0,0,1-1-.83A8.17,8.17,0,0,1,130.89,238.94Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M131.84,236.47s.4.23.95.58,1.31.8,2.08,1.19,1.56.78,2.15,1.08,1,.53,1,.53a8.21,8.21,0,0,1-1.1-.22,11.5,11.5,0,0,1-2.31-.88l-.58-.33c-.19-.12-.37-.25-.54-.37a8.11,8.11,0,0,1-.89-.74A7.53,7.53,0,0,1,131.84,236.47Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm-with-steering-wheel--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.93,232.59v-.09a4.57,4.57,0,0,1,.18-1.34,2.3,2.3,0,0,1,.5-.93,2.17,2.17,0,0,1,.37-.31,1.82,1.82,0,0,1,.88-.21,3.72,3.72,0,0,1,1.87.59,10.26,10.26,0,0,1,3.82,4.43c.15.31.28.62.4.93a9.09,9.09,0,0,1,.48,1.82l2,1.17v-.06a12.59,12.59,0,0,0-5.76-10,5.77,5.77,0,0,0-2.85-.85,3.58,3.58,0,0,0-1.85.49,4.24,4.24,0,0,0-2,3.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.42,234l3.22,1.84.38.23a2.21,2.21,0,0,0,0-.25,4.23,4.23,0,0,0-1.75-2.47,1.37,1.37,0,0,0-1.22-.17A1.07,1.07,0,0,0,98.42,234Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.28,230.13l.83,1L98.39,234l0,0h0l3.22,1.84.33,0,2-.19.88-.07-.08-1-1.2.11-2,.17-1.16.1L99,233.21l-2.39-3-.57-.71Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M80.31,227.74l41.35,23.82,3.81-23.23L84.14,204.46Zm40.24,21.11-38.14-22,2.84-19.7,38.12,22Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.41 226.88 120.55 248.85 123.37 229.19 85.25 207.18 82.41 226.88",
    style: {
      fill: "#BA68C8",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.14 204.46 86.57 203.06 127.91 226.93 125.48 228.33 84.14 204.46",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.91 226.93 124.09 250.16 124.09 258.25 121.66 259.66 121.66 251.56 125.48 228.33 127.91 226.93",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--percentage-box--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.08,253l-3.61-2.1a.84.84,0,0,0-.84-.08l-.85.51a.82.82,0,0,0-.35.77v8.65a2.6,2.6,0,0,0,1.18,2.05l3.61,2.1a.82.82,0,0,0,.84.08l.85-.51a.83.83,0,0,0,.36-.77v-8.65A2.61,2.61,0,0,0,131.08,253Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.27,255.08v8.66a.82.82,0,0,1-.35.76l-.84.5a.86.86,0,0,0,.32-.76v-8.65a2.46,2.46,0,0,0-.34-1.17l.86-.51A2.47,2.47,0,0,1,132.27,255.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.61,262.83l3.61,2.1c.66.38,1.19.07,1.19-.69v-8.65a2.59,2.59,0,0,0-1.19-2.05l-3.61-2.1c-.65-.38-1.18-.07-1.18.69v8.65A2.6,2.6,0,0,0,126.61,262.83Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M123.4,264.27a2.7,2.7,0,0,0-1.22,2.11c0,.77.55,1.09,1.22.7a2.69,2.69,0,0,0,1.21-2.11C124.61,264.2,124.07,263.88,123.4,264.27Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.66,268.35a.84.84,0,0,1-.45-.13l-4-2.29a.3.3,0,1,1,.3-.51l4,2.29a.33.33,0,0,0,.3,0,.3.3,0,0,0,.15-.26v-8.79a.3.3,0,0,1,.3-.3.29.29,0,0,1,.3.3v8.79a.88.88,0,0,1-.45.77A.81.81,0,0,1,127.66,268.35Z",
    style: {
      fill: "#263238"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--car-1--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Car--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.6,274.76a3.35,3.35,0,0,0,2.16-3,4.4,4.4,0,0,0-2.22-4.66,4.71,4.71,0,0,0-4.91-.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.66,274.94a2.44,2.44,0,0,1-1-.4L180.26,273a3.84,3.84,0,0,1-1.64-3.31l.2-1.82a1.56,1.56,0,0,1,1.76-1.48,2.33,2.33,0,0,1,1,.4l2.36,1.57a3.81,3.81,0,0,1,1.64,3.3l-.2,1.82A1.55,1.55,0,0,1,183.66,274.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.22,267.24l2.36,1.57a3.25,3.25,0,0,1,1.37,2.75l-.2,1.82c-.1.94-.88,1.25-1.74.67l-2.36-1.57a3.24,3.24,0,0,1-1.37-2.74l.2-1.82C179.59,267,180.37,266.67,181.22,267.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.93,267.71l-2.63,1.9.22-2.11.75-.54a1.41,1.41,0,0,1,1,.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,269.13,180.06,272a3.89,3.89,0,0,1-.28-.39h0l3.79-2.73A1.9,1.9,0,0,1,184,269.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.94,271.56l0,.31-2.48,1.8-1.09-.73,3.45-2.49A2.43,2.43,0,0,1,184.94,271.56Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "191.88 342.9 174.36 332.79 186.04 326.05 203.55 336.16 191.88 342.9",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.88 342.9 174.36 332.79 186.04 326.05 203.55 336.16 191.88 342.9",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.1 309.34 232.59 299.23 235.43 295.68 252.94 305.8 250.1 309.34",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.1 309.34 232.59 299.23 235.43 295.68 252.94 305.8 250.1 309.34",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.88,343.8l2-4-4.77-2.76h0c-1.51-.87-3.53-.77-5.75.51-4.7,2.72-8.52,9.73-8.52,15.66,0,3.1,1,5.29,2.72,6.29h0l.07,0h0l4.88,2.82,2.11-4.19A20.37,20.37,0,0,0,185.88,343.8Z",
    style: {
      fill: "#37474f"
    }
  }), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M185.88,343.8l2-4-4.77-2.76h0c-1.51-.87-3.53-.77-5.75.51-4.7,2.72-8.52,9.73-8.52,15.66,0,3.1,1,5.29,2.72,6.29h0l.07,0h0l4.88,2.82,2.11-4.19A20.37,20.37,0,0,0,185.88,343.8Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M190.84,346.25a20.41,20.41,0,0,1-6.63,14.3h0a12.17,12.17,0,0,1-1.87,1.34c-4.71,2.72-8.52.12-8.52-5.81a20.62,20.62,0,0,1,5.27-13l0,0a13.69,13.69,0,0,1,3.22-2.66C187,337.72,190.84,340.32,190.84,346.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.32,344c3-1.73,5.43.07,5.43,4s-2.43,8.56-5.43,10.29-5.42-.08-5.42-4S179.33,345.74,182.32,344Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.77,350.07c-.2,2-1.47,4.05-2.82,4.66a1.32,1.32,0,0,1-1.48-.13,2.71,2.71,0,0,1-.6-2.34c.21-2,1.47-4.05,2.82-4.65a1.52,1.52,0,0,1,1-.13h0C184.47,347.67,184.92,348.64,184.77,350.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.84,346.25a20.41,20.41,0,0,1-6.63,14.3,24.13,24.13,0,0,0,5.4-10.46c.72-3.42.45-8.33-2.48-9.57s-6.81,1.38-8,2.57a13.69,13.69,0,0,1,3.22-2.66C187,337.72,190.84,340.32,190.84,346.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.1,310.24l2-4-4.77-2.76h0c-1.52-.87-3.53-.77-5.75.51-4.71,2.72-8.52,9.73-8.52,15.66,0,3.1,1,5.29,2.72,6.29h0l.06,0h0l4.89,2.82,2.11-4.19A20.32,20.32,0,0,0,244.1,310.24Z",
    style: {
      fill: "#37474f"
    }
  }), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M244.1,310.24l2-4-4.77-2.76h0c-1.52-.87-3.53-.77-5.75.51-4.71,2.72-8.52,9.73-8.52,15.66,0,3.1,1,5.29,2.72,6.29h0l.06,0h0l4.89,2.82,2.11-4.19A20.32,20.32,0,0,0,244.1,310.24Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M249.07,312.69a20.44,20.44,0,0,1-6.64,14.3h0a12.17,12.17,0,0,1-1.87,1.34c-4.71,2.72-8.53.12-8.52-5.81a20.57,20.57,0,0,1,5.27-13l0,0a13.69,13.69,0,0,1,3.22-2.66C245.26,304.16,249.07,306.76,249.07,312.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.55,310.45c3-1.73,5.42.07,5.42,4s-2.43,8.55-5.42,10.28-5.43-.07-5.43-4S237.55,312.18,240.55,310.45Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,316.51c-.21,2-1.47,4.05-2.82,4.66a1.33,1.33,0,0,1-1.48-.13,2.69,2.69,0,0,1-.6-2.34c.2-2,1.47-4.05,2.82-4.65a1.5,1.5,0,0,1,1-.13h0C242.69,314.11,243.15,315.08,243,316.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.07,312.69a20.44,20.44,0,0,1-6.64,14.3,24.14,24.14,0,0,0,5.41-10.46c.72-3.42.45-8.33-2.48-9.57s-6.81,1.38-8,2.57a13.69,13.69,0,0,1,3.22-2.66C245.26,304.16,249.07,306.76,249.07,312.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.06,293.38v5.68c0,3.15-2.79,7.3-6.22,9.28l-1.74,1c-1-4.92-4.89-6.77-9.56-4.08a15.59,15.59,0,0,0-3.71,3.05l0,0a24.38,24.38,0,0,0-5.82,12L191.87,342.9c-1-4.92-4.88-6.77-9.56-4.09a16.64,16.64,0,0,0-3.7,3.07l0,0a24.32,24.32,0,0,0-5.82,12l-3.86,2.22c-3.43,2-6.63,2.13-12.44,0S134.84,345.32,128,339.75c-4.45-3.59-6.22-6.61-6.22-10.34v-6.74c0-.33,0-.67,0-1s0-.63.06-.95a28.13,28.13,0,0,1,.5-4,16.46,16.46,0,0,1,.38-1.75,36.47,36.47,0,0,1,4.41-10.83c4.2-6.62,5.81-8.13,10-10.58L151,299.09l54.5-31.42c7.49-4.33,27.51-3,39.13,4.38S258.06,285.69,258.06,293.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.06,293.38v5.68c0,3.15-2.79,7.3-6.22,9.28l-1.74,1c-1-4.92-4.89-6.77-9.56-4.08a15.59,15.59,0,0,0-3.71,3.05l0,0a24.38,24.38,0,0,0-5.82,12L191.87,342.9c-1-4.92-4.88-6.77-9.56-4.09a16.64,16.64,0,0,0-3.7,3.07l0,0a24.32,24.32,0,0,0-5.82,12l-3.86,2.22c-3.43,2-6.63,2.13-12.44,0S134.84,345.32,128,339.75c-4.45-3.59-6.22-6.61-6.22-10.34v-6.74c0-.33,0-.67,0-1s0-.63.06-.95a28.13,28.13,0,0,1,.5-4,16.46,16.46,0,0,1,.38-1.75,36.47,36.47,0,0,1,4.41-10.83c4.2-6.62,5.81-8.13,10-10.58L151,299.09l44.72-25.78c4.56-2.63,36,21.07,37.87,20.53,10.54-3.11,18.43-8.24,19.74-14.62C257.26,283.8,258.06,288.28,258.06,293.38Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.88,312.22,137,293.7c-4,2.36-5.69,3.94-9.8,10.43A36.47,36.47,0,0,0,122.77,315a16.46,16.46,0,0,0-.38,1.75,28.13,28.13,0,0,0-.5,4c0,.32,0,.64-.06.95s0,.66,0,1v6.74c0,3.73,1.77,6.75,6.22,10.34,6.8,5.57,22.61,14.29,28.42,16.41,3.82,1.4,6.51,1.8,8.88,1.36-.94-2.46-.09-7.63,1.2-17.67C168.18,327.06,170.36,317.28,174.88,312.22Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.75,294.44c2.23-1.32,3.24-3.24,2.36-5.31l-23.75-4.59,0,6.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.16,269.77h23.36c3.75,0,10.25,2.18,18.38,7.51s16.79,12.35,9.7,16.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,270.52H206.3c3.65,0,10.89,3.89,16.73,7.26s14.77,11.7,11.68,13.48c-1.14.66-3.85.33-11.68-.65l-10-1.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.47,286.55A43,43,0,0,0,223,277.78c-5.84-3.37-13.08-7.26-16.73-7.26H183l10.82,6.77L196.6,276c-3.54-2.06,6.4-3.1,12.05-2.33S229.32,281.31,233.47,286.55Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.87,315.43a39.79,39.79,0,0,0-.16,6.92c.08,2.3,1.83,3.33,3.9,2.14l52.14-30.05c2.06-1.19,1.82-2.39-.54-2.69l-13.57-1.69a15,15,0,0,0-8,1.62l-30,17.28C178.54,310.15,177.21,312.16,176.87,315.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,315.11a28.67,28.67,0,0,0-.24,7c.16,1.33,1.35,1.83,2.73,1l48.4-27.9c1.38-.79,1.21-1.59-.36-1.79l-11.81-1.5a10,10,0,0,0-5.34,1.08l-30.9,17.8C179.09,311.59,178.41,312.47,178,315.11Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.49 298.35 199.49 313.29 200.47 312.73 200.47 297.78 199.49 298.35",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "217.19 290.91 217.19 303.05 218.18 302.48 218.18 290.34 217.19 290.91",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.79,313.78a8.26,8.26,0,0,0,7.47,0L211,291.49c3.44-2,3.44-5.21,0-7.19l-22.58-13a13.79,13.79,0,0,0-12.45,0l-38.71,22.3c-2.07,1.19-2.07,3.12,0,4.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167,310.28c-6.29-2.89-10.68-5.26-15.87-10.06s-2.15-11.14,10.39-20.71l-24.32,14.05c-2.07,1.19-2.07,3.12,0,4.31l27.56,15.91a8.26,8.26,0,0,0,7.47,0l12.86-7.42C185,306.4,173.29,313.16,167,310.28Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211,284.3l-22.58-13a13.67,13.67,0,0,0-8.47-1.3,10.74,10.74,0,0,1,5.16,1.08c2.92,1.26,11.37,6.26,20.9,11.52s5.79,7.19,3.17,8.7-32.75,20.13-36.89,22.52L211,291.49C214.41,289.5,214.41,286.28,211,284.3Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.13,337.43v-5.11c0-.64.45-.9,1-.58l8.69,5a1.75,1.75,0,0,1,.79,1.36v5.05c0,.63-.45.89-1,.58l-8.69-5A1.71,1.71,0,0,1,134.13,337.43Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.76,326.16v-.67c0-.79.56-1.11,1.25-.72l8,4.62a2.72,2.72,0,0,1,1.24,2.15v.61c0,.79-.56,1.12-1.24.72l-8-4.56A2.72,2.72,0,0,1,135.76,326.16Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.76,326.16v-.67c0-.79.56-1.11,1.25-.72l8,4.62a2.72,2.72,0,0,1,1.24,2.15v.61c0,.79-.56,1.12-1.24.72l-8-4.56A2.72,2.72,0,0,1,135.76,326.16Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.08,335.54a5.7,5.7,0,0,0-4.44,4c-.7,2.93.37,5.39,2.79,6,1,.27,3.59-.15,5.6-3.05,1.38-2,1.56-5.13.8-6.13S161,335,159.08,335.54Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,338.84a1.92,1.92,0,1,1-1.92-1.92A1.92,1.92,0,0,1,160,338.84Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.47,342.74a1.14,1.14,0,1,1-1.14-1.14A1.14,1.14,0,0,1,158.47,342.74Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.12,325.39c-.39.58-1.28.56-2.3-.68v-2c0-.33,0-.67,0-1s0-.63.06-.95a28.13,28.13,0,0,1,.5-4,16.46,16.46,0,0,1,.38-1.75,6,6,0,0,1,1.88,3.63C124.84,320.93,124.65,324.66,124.12,325.39Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.5,321.65a1,1,0,0,0-.67.26c0,.26,0,.5,0,.76v.77a1,1,0,0,0,.68.27,1,1,0,0,0,0-2.06Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.87,318.68a2,2,0,0,1-2,2.05,28.13,28.13,0,0,1,.5-4A2.06,2.06,0,0,1,123.87,318.68Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.86,275.82c4.45,5.66-8.63,14.82-14.52,18.16s-42.75,24.72-42.75,24.72,45.48-24.07,56.48-28.09c7.27-2.66,9,6.4,9,8.45h0v-5.67C258.07,287,256.82,281.64,249.86,275.82Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.86,275.82c4.45,5.66-8.63,14.82-14.52,18.16s-42.75,24.72-42.75,24.72,45.48-24.07,56.48-28.09c7.27-2.66,9,6.4,9,8.45h0v-5.67C258.07,287,256.82,281.64,249.86,275.82Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.65,339.46a19.3,19.3,0,0,1,3.8-3.47,12.59,12.59,0,0,1,4.75-2,8.22,8.22,0,0,1,2.62,0,6.35,6.35,0,0,1,2.39,1.06,7.9,7.9,0,0,1,2.79,4.26,8.4,8.4,0,0,0-2.95-4,6.61,6.61,0,0,0-2.29-1,8.06,8.06,0,0,0-2.5,0,12.77,12.77,0,0,0-4.66,1.89A23,23,0,0,0,177.65,339.46Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.69,305.94a19.24,19.24,0,0,1,3.79-3.47,12.71,12.71,0,0,1,4.76-2,8.23,8.23,0,0,1,2.62,0,6.35,6.35,0,0,1,2.39,1.06,7.89,7.89,0,0,1,2.78,4.26,8.39,8.39,0,0,0-2.94-4,6.85,6.85,0,0,0-2.3-1,8,8,0,0,0-2.49,0,12.7,12.7,0,0,0-4.66,1.89A22.72,22.72,0,0,0,235.69,305.94Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.42,338.43q8.09-5.18,16.38-10c2.76-1.62,5.52-3.24,8.31-4.79s5.56-3.16,8.38-4.67l-.19.3a20.15,20.15,0,0,1,1.46-5.37,14,14,0,0,1,3.05-4.57,15.42,15.42,0,0,0-2.62,4.74,21.31,21.31,0,0,0-1.13,5.26l0,.19-.17.11c-2.72,1.68-5.5,3.27-8.25,4.89s-5.53,3.2-8.32,4.77Q204,334.06,195.42,338.43Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.76,281.06c.9,2.45-1.47,6.06-1.09,9.52s3.12,3.71,4.29,0C258.49,286.66,255.64,281.6,254.76,281.06Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.76,281.06c.9,2.45-1.47,6.06-1.09,9.52s3.12,3.71,4.29,0C258.49,286.66,255.64,281.6,254.76,281.06Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,309.44a48.77,48.77,0,0,1,6.86-9.74,3.47,3.47,0,0,1,4.38-.34A184.06,184.06,0,0,0,166,315.93a2.75,2.75,0,0,1,1.29,3.75,59.32,59.32,0,0,0-3.89,11.5,2.4,2.4,0,0,1-3.31,1.76,123.94,123.94,0,0,1-33.22-19.09A3.68,3.68,0,0,1,126,309.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,332.13a1.59,1.59,0,0,1-.59-.12,123.45,123.45,0,0,1-33-18.94,2.67,2.67,0,0,1-.61-3.14,47.43,47.43,0,0,1,6.71-9.55,2.22,2.22,0,0,1,1.62-.63,2.48,2.48,0,0,1,1.44.43,187.4,187.4,0,0,0,28.9,16.66,1.65,1.65,0,0,1,.9,1,1.82,1.82,0,0,1-.09,1.44,60.42,60.42,0,0,0-4,11.69A1.42,1.42,0,0,1,161,332.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.43,317.81a1.65,1.65,0,0,0-.9-1,188,188,0,0,1-25.05-14l-13.87,8a2.69,2.69,0,0,0,.86,2.25,123.45,123.45,0,0,0,33,18.94,1.59,1.59,0,0,0,.59.12,1.42,1.42,0,0,0,1.36-1.19,60.42,60.42,0,0,1,4-11.69A1.82,1.82,0,0,0,166.43,317.81Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.1,329.41c.41,1.94,6.74,8.12,17.21,13.94s19.25,10.55,24.55,10.29,12-4.72,12-4.72a31.94,31.94,0,0,0-1.36,5.72s-5.52,3.48-10.08,3.83c-3,.22-6.94.81-25.27-9.77-12.16-7-15.87-10.87-17.25-13.95a12.65,12.65,0,0,1-.65-4.89c.07-3.47,1.55-3.81,1.55-3.81C121.15,326.69,120.68,327.48,121.1,329.41Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.1,329.41c.41,1.94,6.74,8.12,17.21,13.94s19.25,10.55,24.55,10.29,12-4.72,12-4.72a31.94,31.94,0,0,0-1.36,5.72s-5.52,3.48-10.08,3.83c-3,.22-6.94.81-25.27-9.77-12.16-7-15.87-10.87-17.25-13.95a12.65,12.65,0,0,1-.65-4.89c.07-3.47,1.55-3.81,1.55-3.81C121.15,326.69,120.68,327.48,121.1,329.41Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.82,326.05c-.67.64-1.14,1.43-.72,3.36s6.74,8.12,17.21,13.94,19.25,10.55,24.55,10.29,12-4.72,12-4.72l-.6-.34s-6.82,4.33-11.44,4.27S152,350.47,139,342.9s-16.52-12.16-17.12-13.77Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.31,302.33a3.35,3.35,0,0,0,2.16-3,4.4,4.4,0,0,0-2.22-4.66,4.71,4.71,0,0,0-4.91-.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.37,302.5a2.3,2.3,0,0,1-1-.39L228,300.53a3.81,3.81,0,0,1-1.64-3.3l.2-1.82a1.57,1.57,0,0,1,1.76-1.49,2.45,2.45,0,0,1,1,.4l2.36,1.57a3.84,3.84,0,0,1,1.64,3.31l-.2,1.82A1.55,1.55,0,0,1,231.37,302.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.93,294.81l2.36,1.57a3.24,3.24,0,0,1,1.37,2.74l-.2,1.82c-.1.95-.88,1.25-1.74.68l-2.36-1.57A3.25,3.25,0,0,1,227,297.3l.2-1.82C227.3,294.54,228.08,294.24,228.93,294.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.64,295.28,227,297.17l.22-2.1.75-.54a1.41,1.41,0,0,1,1,.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.68,296.7l-3.91,2.82c-.1-.12-.19-.26-.28-.39h0l3.79-2.74A2.37,2.37,0,0,1,231.68,296.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.65,299.13l0,.31-2.48,1.79-1.09-.72L232.5,298A2.43,2.43,0,0,1,232.65,299.13Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M175.46,319.61c.14,3,.16,6.05.37,9.06a13,13,0,0,0,.88,4.37,1.92,1.92,0,0,0,1.56,1.26,5.5,5.5,0,0,0,2.1-.57,32.69,32.69,0,0,1,4.35-1.35,10.74,10.74,0,0,1,4.55-.16,6.22,6.22,0,0,1,3.77,2.47,13,13,0,0,1,1.81,4.15,13,13,0,0,0-1.95-4,6.06,6.06,0,0,0-3.68-2.34,10.53,10.53,0,0,0-4.43.23,32,32,0,0,0-4.29,1.39c-.36.12-.69.28-1.08.38-.19.05-.38.12-.57.15l-.61,0a2.22,2.22,0,0,1-1.79-1.46,13.1,13.1,0,0,1-.86-4.48C175.39,325.66,175.46,322.64,175.46,319.61Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M200.65,313.38c.15,3.69.16,7.37.18,11.06l0,5.53c0,1.84-.07,3.69-.14,5.53-.07-1.84-.11-3.69-.14-5.53l0-5.53C200.49,320.75,200.5,317.07,200.65,313.38Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M225.59,299.05c.15,3.67.16,7.35.18,11l0,5.51c0,1.84-.07,3.67-.14,5.51-.06-1.84-.11-3.67-.13-5.51l-.05-5.51C225.44,306.4,225.45,302.72,225.59,299.05Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M183.22,325.34l3.41-1.95c.69-.39,1.25-.33,1.25.13a2.36,2.36,0,0,1-1.25,1.56L183.22,327c-.69.4-1.25.34-1.25-.13A2.34,2.34,0,0,1,183.22,325.34Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.63,313.52l3.41-1.94c.69-.4,1.25-.34,1.25.13a2.34,2.34,0,0,1-1.25,1.55l-3.41,1.95c-.69.39-1.25.33-1.25-.13A2.36,2.36,0,0,1,203.63,313.52Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Locator--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pin--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.82,138.59v-4.11a52.21,52.21,0,0,1,2.66-15.8h0c4.31-13.36,13.39-26.1,23.88-32.16,6.68-3.85,12.79-4.33,17.45-2L97.62,79.2A13.57,13.57,0,0,0,90,77c-.43,0-.86,0-1.3.06s-.88.08-1.33.15a13.2,13.2,0,0,0-1.37.26c-.45.1-.92.23-1.39.37a23.69,23.69,0,0,0-2.89,1.07c-.48.21-1,.45-1.48.69s-1,.53-1.49.81c-14.65,8.47-26.52,29.94-26.52,48v4.11c0,18,24.24,37.63,24.24,37.63l9.83,5.55a3.39,3.39,0,0,1-.5-.37C78.55,168.58,62.82,152.47,62.82,138.59Zm29-37.91a11.57,11.57,0,0,1,.17,1.38c0,.15,0,.31,0,.48a7.49,7.49,0,0,1,0,.83c0,8.44-5.93,18.74-13.27,23-.27.16-.53.3-.8.43a7.92,7.92,0,0,1-.78.37l-.77.31-.07,0c1.14,6.47,6.53,8.73,13,5,7.32-4.24,13.25-14.52,13.25-23C102.61,102,98,98.43,91.78,100.68Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.82,138.59v-4.11a52.21,52.21,0,0,1,2.66-15.8h0c4.31-13.36,13.39-26.1,23.88-32.16,6.68-3.85,12.79-4.33,17.45-2L97.62,79.2A13.57,13.57,0,0,0,90,77c-.43,0-.86,0-1.3.06s-.88.08-1.33.15a13.2,13.2,0,0,0-1.37.26c-.45.1-.92.23-1.39.37a23.69,23.69,0,0,0-2.89,1.07c-.48.21-1,.45-1.48.69s-1,.53-1.49.81c-14.65,8.47-26.52,29.94-26.52,48v4.11c0,18,24.24,37.63,24.24,37.63l9.83,5.55a3.39,3.39,0,0,1-.5-.37C78.55,168.58,62.82,152.47,62.82,138.59Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.78,100.68a11.57,11.57,0,0,1,.17,1.38c0,.15,0,.31,0,.48a7.49,7.49,0,0,1,0,.83c0,8.44-5.93,18.74-13.27,23-.27.16-.53.3-.8.43a7.92,7.92,0,0,1-.78.37l-.77.31-.07,0c1.14,6.47,6.53,8.73,13,5,7.32-4.24,13.25-14.52,13.25-23C102.61,102,98,98.43,91.78,100.68Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.88,103.85c0-18-11.87-25.8-26.53-17.34s-26.52,29.94-26.52,48v4.1c0,13.89,15.73,30,23,36.68a3.57,3.57,0,0,0,5.64-1c6.25-12.79,24.45-51.32,24.45-66.26ZM89.35,132.46c-7.32,4.23-13.26.8-13.26-7.66s5.94-18.74,13.26-23,13.27-.8,13.27,7.65S96.68,128.23,89.35,132.46Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.81,84.49,97.62,79.2A13.57,13.57,0,0,0,90,77c-.43,0-.86,0-1.3.06s-.88.08-1.33.15a13.2,13.2,0,0,0-1.37.26c-.45.1-.92.23-1.39.37a23.69,23.69,0,0,0-2.89,1.07c-.48.21-1,.45-1.48.69s-1,.53-1.49.81c-9.91,5.73-18.54,17.4-23.09,29.94l10.6,6.12c4.56-12.52,13.2-24.21,23.11-29.93C96,82.66,102.15,82.18,106.81,84.49Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.81,84.49,97.62,79.2A13.57,13.57,0,0,0,90,77c-.43,0-.86,0-1.3.06s-.88.08-1.33.15a13.2,13.2,0,0,0-1.37.26c-.45.1-.92.23-1.39.37a23.69,23.69,0,0,0-2.89,1.07c-.48.21-1,.45-1.48.69s-1,.53-1.49.81c-9.91,5.73-18.54,17.4-23.09,29.94l10.6,6.12c4.56-12.52,13.2-24.21,23.11-29.93C96,82.66,102.15,82.18,106.81,84.49Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.37,86.51l-1.58,1.08a18.8,18.8,0,0,0-1.54,1.11c-1,.82-2,1.55-2.91,2.45s-1.87,1.7-2.72,2.65l-1.3,1.38-1.21,1.46a66.34,66.34,0,0,0-8.27,12.69,65.59,65.59,0,0,0-5.32,14.17c-.33,1.22-.52,2.47-.79,3.71s-.35,2.51-.53,3.76-.18,2.53-.25,3.8l-.11,3.81-.12-3.81c0-1.28,0-2.55.06-3.83s.22-2.55.41-3.82.38-2.53.69-3.77a62.67,62.67,0,0,1,5.19-14.41A63.51,63.51,0,0,1,77.6,96.21,43.59,43.59,0,0,1,89.37,86.51Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.37,86.51l-1.58,1.08a18.8,18.8,0,0,0-1.54,1.11c-1,.82-2,1.55-2.91,2.45s-1.87,1.7-2.72,2.65l-1.3,1.38-1.21,1.46a66.34,66.34,0,0,0-8.27,12.69,65.59,65.59,0,0,0-5.32,14.17c-.33,1.22-.52,2.47-.79,3.71s-.35,2.51-.53,3.76-.18,2.53-.25,3.8l-.11,3.81-.12-3.81c0-1.28,0-2.55.06-3.83s.22-2.55.41-3.82.38-2.53.69-3.77a62.67,62.67,0,0,1,5.19-14.41A63.51,63.51,0,0,1,77.6,96.21,43.59,43.59,0,0,1,89.37,86.51Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Keys--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--keys--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.77,377.45c0-2.22-2.8-3.9-6.68-4a567.36,567.36,0,0,0-65.37,2.71c-4.12.41-7.49,2.52-7.78,4.89l-2.4,19.3c0,.11,0,.22,0,.33V408c0,2.21,2.8,3.9,6.66,4a568.42,568.42,0,0,0,65.37-2.71c4.13-.41,7.5-2.52,7.8-4.9l2.4-19.29a1.94,1.94,0,0,0,0-.34Zm-9.08,11.2a1.6,1.6,0,0,1,.89-1.09,4.27,4.27,0,0,1,1.9-.52,3.45,3.45,0,0,1,1.66.3l-.83,6.63a1.6,1.6,0,0,1-.89,1.09,4.27,4.27,0,0,1-1.9.52,3.43,3.43,0,0,1-1.65-.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.09,373.48a567.36,567.36,0,0,0-65.37,2.71c-4.12.41-7.49,2.52-7.78,4.89l-2.4,19.3c-.3,2.38,2.58,4.23,6.64,4.3A566.2,566.2,0,0,0,103.55,402c4.13-.4,7.5-2.52,7.8-4.89l2.4-19.29C114,375.4,111.16,373.55,107.09,373.48ZM108.31,394a1.6,1.6,0,0,1-.89,1.09,4.27,4.27,0,0,1-1.9.52c-1.45.06-2.53-.56-2.43-1.39l1.6-12.81a1.63,1.63,0,0,1,.89-1.1,4.27,4.27,0,0,1,1.9-.52c1.45-.06,2.53.57,2.43,1.4Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.08,377c0-.37-.5-.63-1.15-.58q-7,.51-14,1.21c-.35,0-.64.2-.66.4l-2.4,19.3v2.8c0,.18.24.31.57.32q6.87.12,13.84.05c.66,0,1.26-.34,1.31-.72l2.48-20V377Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6,397l2.48-20c.05-.38-.48-.67-1.15-.62q-7,.51-14,1.21c-.35,0-.64.2-.66.4l-2.4,19.3c0,.19.22.34.57.35q6.87.12,13.84,0C54,397.7,54.55,397.37,54.6,397Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.89,375.53c0-.34-.38-.62-1-.62q-7.51-.06-15,.09c-.66,0-1.25.34-1.29.72L82,396v2.81c0,.36.49.63,1.13.59q7.58-.48,15.18-1.16c.61-.06,1.11-.37,1.15-.72l2.39-19.23C101.91,378.12,101.89,375.53,101.89,375.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.57,375.72,82,396c0,.38.47.67,1.13.63q7.58-.48,15.18-1.16c.61-.06,1.11-.37,1.15-.72l2.39-19.23c0-.34-.38-.62-1-.62q-7.51-.06-15,.09C85.2,375,84.61,375.34,84.57,375.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.73,375.75v0c0-.35-.45-.6-1.06-.58-6.5.19-13,.49-19.52.91-.63,0-1.16.36-1.2.72L57.43,397v.05c0,.16,0,2.75,0,2.77,0,.33.44.59,1,.58q9.69-.18,19.5-.71c.63,0,1.18-.35,1.22-.72l2.55-20.47v-2.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,376.76,57.43,397c0,.36.41.64,1,.63q9.69-.18,19.5-.71c.63,0,1.18-.35,1.22-.72l2.55-20.47c0-.36-.43-.64-1.06-.62-6.5.19-13,.49-19.52.91C60.52,376.08,60,376.4,60,376.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.36,385a1.61,1.61,0,0,0-.74.23l-1.84.07-.09.73,1.84-.08a1.14,1.14,0,0,0,.69.17c.53,0,1-.29,1-.6S90.89,385,90.36,385Zm-.11.9a.66.66,0,0,1-.46-.13l-.05,0-1.65.07,0-.3,1.66-.07.06,0a.83.83,0,0,1,.49-.17c.33,0,.58.13.56.32S90.58,385.91,90.25,385.92Zm3-1.2-.16-1c0-.13-.21-.22-.45-.21l-5.82.24c-.27,0-.51.14-.53.3l-.41,3.33c0,.16.19.28.46.26l5.81-.24a.6.6,0,0,0,.52-.25l.4-1A2.73,2.73,0,0,0,93.21,384.72Zm-.54,1.46-.4,1a.16.16,0,0,1-.13.06l-5.82.24c-.07,0-.12,0-.11-.06l.41-3.33a.14.14,0,0,1,.14-.08l5.81-.24a.11.11,0,0,1,.12.05l.15,1a2.35,2.35,0,0,1,0,.7A2.67,2.67,0,0,1,92.67,386.18ZM94,384l-.74,0,0,.22.75,0c1.19-.05,2.09.47,2,1.15s-1.12,1.29-2.31,1.34l-.75,0,0,.22.75,0c1.4-.06,2.61-.77,2.71-1.57S95.41,383.91,94,384Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.66,386.84a1.5,1.5,0,0,0-.74.22l-1.84.07-.09.73,1.84-.08a1.14,1.14,0,0,0,.69.17c.54,0,1-.29,1-.6S47.19,386.81,46.66,386.84Zm-.11.9a.74.74,0,0,1-.46-.13l-.05-.05-1.65.07,0-.3,1.66-.07.06,0a.84.84,0,0,1,.5-.17c.32,0,.57.13.55.32S46.88,387.72,46.55,387.74Zm3-1.2-.16-1c0-.13-.21-.22-.45-.21l-5.82.24c-.27,0-.5.15-.52.3l-.42,3.33c0,.16.19.28.46.27l5.81-.25a.6.6,0,0,0,.52-.25l.4-1A2.6,2.6,0,0,0,49.51,386.54ZM49,388l-.4,1s-.07.06-.13.06l-5.81.24c-.07,0-.13,0-.12-.06l.41-3.33a.14.14,0,0,1,.14-.08l5.81-.24c.06,0,.11,0,.12.05l.16,1a2.34,2.34,0,0,1,0,.7A2.61,2.61,0,0,1,49,388Zm4.61-1.34-.49-.29-.28.17.49.28c.79.45.69,1.24-.21,1.76a3.39,3.39,0,0,1-3.06.13l-.49-.28-.28.16.49.28a4,4,0,0,0,3.58-.15C54.39,388.1,54.5,387.18,53.58,386.65Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.36,381.73c-.1,0-.19,0-.2.11h0l-.08.85-1.47,1-.13-.07a.56.56,0,0,1-.25-.26l-.32-.91a1.21,1.21,0,0,0-1.16-.55,2.35,2.35,0,0,0-1.1.26.89.89,0,0,0-.54.62v.11c-.76.13-1.34.52-1.39,1s.42.79,1.16.86l-.46,3.71c-.76.13-1.33.52-1.39,1s.43.79,1.16.86l0,.27c0,.3.36.53.9.51l.53,0a1.84,1.84,0,0,0,1.44-.65l.85-1.43a.68.68,0,0,1,.2-.22l1.39-1a.87.87,0,0,0,.35-.48l.4-2.23a.57.57,0,0,0-.35-.59l-1-.56,1.54-1a.1.1,0,0,0,.06-.07h0l.08-.88C73.54,381.77,73.46,381.72,73.36,381.73ZM72.85,385l-.41,2.23a.58.58,0,0,1-.26.36l-1.39,1a1,1,0,0,0-.27.28l-.85,1.43a1.33,1.33,0,0,1-1.06.49l-.54,0c-.33,0-.58-.13-.55-.32l0-.35c0-.05-.06-.1-.15-.1-.64,0-1.07-.31-1-.67s.55-.69,1.2-.77c.1,0,.17-.06.18-.11l.48-3.88s-.06-.09-.15-.1c-.64,0-1.07-.31-1-.67s.55-.69,1.2-.77c.09,0,.17-.06.17-.11l0-.2a.68.68,0,0,1,.39-.46,1.87,1.87,0,0,1,.82-.19.9.9,0,0,1,.86.41l.32.91a.68.68,0,0,0,.34.35l1.37.77A.45.45,0,0,1,72.85,385Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.48,416.2a4.14,4.14,0,0,0-2-3.33,91,91,0,0,0-12.75-7.4c-4.15-2-10.74-1.55-15,1.06L108.89,415c-3.85,2.36-5.82,5.3-5.81,8.1,0,1.23,0,6,0,7.29,0,2.35,1.39,4.59,4.23,6.29.51.31,1,.61,1.57.91,6.44,3.59,17.44,3.18,25-.92l14.62-8c2.67-1.45,4.07-3.39,4-5.22C152.46,422.24,152.5,417.51,152.48,416.2Zm-8,4.13-.92.5a3.75,3.75,0,0,0-.58-1.45C143.51,419.69,144,420,144.5,420.33Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.71,406.53,108.89,415c-7.1,4.34-7.82,10.69-1.59,14.41.51.31,1,.61,1.57.91,6.44,3.59,17.44,3.18,25-.92l14.62-8c4.44-2.41,5.38-6.19,2-8.54a91,91,0,0,0-12.75-7.4C133.57,403.48,127,403.92,122.71,406.53Zm3,1.61a10.28,10.28,0,0,1,8.91-.62c2.13,1,4.23,2.13,6.22,3.27s4.14,2.52,6.06,3.86,1.42,3.59-1.22,5l-2.1,1.15a4.37,4.37,0,0,0-2-2.85,90,90,0,0,0-12.75-7.39,13.69,13.69,0,0,0-5.17-1.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.89,
    cy: 421.53,
    rx: 2,
    ry: 1.15,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.07,423.47a.86.86,0,0,1,0,1.63,3.14,3.14,0,0,1-2.83,0,.86.86,0,0,1,0-1.63A3.14,3.14,0,0,1,118.07,423.47Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.84,426.23a.86.86,0,0,1,0,1.63,3.14,3.14,0,0,1-2.83,0,.86.86,0,0,1,0-1.63A3.14,3.14,0,0,1,122.84,426.23Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.49,417.15a.86.86,0,0,1,0,1.63,3.14,3.14,0,0,1-2.83,0,.86.86,0,0,1,0-1.63A3.14,3.14,0,0,1,119.49,417.15Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.26,419.9a.86.86,0,0,1,0,1.63,3.14,3.14,0,0,1-2.83,0,.86.86,0,0,1,0-1.63A3.14,3.14,0,0,1,124.26,419.9Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.62,
    cy: 423.47,
    rx: 2,
    ry: 1.15,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.68,413.58a.86.86,0,0,1,0,1.63,3.14,3.14,0,0,1-2.83,0,.86.86,0,0,1,0-1.63A3.14,3.14,0,0,1,125.68,413.58Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.45,416.33a.86.86,0,0,1,0,1.63,3.07,3.07,0,0,1-2.83,0,.86.86,0,0,1,0-1.63A3.14,3.14,0,0,1,130.45,416.33Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.22,419.09a.86.86,0,0,1,0,1.63,3.14,3.14,0,0,1-2.83,0,.86.86,0,0,1,0-1.63A3.14,3.14,0,0,1,135.22,419.09Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.97 435.1 105.92 431.03 89.35 440.6 88.59 442.85 83.84 444.38 81.81 446.92 79.36 447.76 78.65 449.04 77.34 449.09 76.58 449.93 73.18 451.05 71.65 454.89 71.65 458.16 78.3 457.28 80.23 455.31 81.69 454.88 81.78 454.12 83.99 453.71 85.46 452.3 89.85 451.12 92.5 448.38 96.4 447.94 112.97 438.37 112.97 435.1",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.92 431.03 112.97 435.1 96.4 444.67 92.5 445.11 89.85 447.85 85.46 449.02 83.99 450.44 81.78 450.85 81.69 451.6 80.23 452.04 78.3 454 71.65 454.89 73.18 451.05 76.58 449.93 77.34 449.09 78.65 449.04 79.36 447.76 81.81 446.92 83.84 444.38 88.59 442.85 89.35 440.6 105.92 431.03",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.3 454 78.3 457.28 80.23 455.31 80.23 452.04 78.3 454",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.69 451.6 81.69 454.88 81.78 454.12 81.78 450.85 81.69 451.6",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.99 450.44 85.46 449.02 85.46 452.3 83.99 453.71 83.99 450.44",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.5 445.11 92.5 448.38 89.85 451.12 89.85 447.85 92.5 445.11",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "96.4 444.67 96.4 447.94 112.97 438.37 112.97 435.1 96.47 444.73",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.25 436.21 104.28 436.8 76.7 452.73 75.67 452.13 103.25 436.21",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.11 452.39 76.7 452.73 103.83 437.06 103.25 436.73 76.11 452.39",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.25 436.73 103.25 436.21 104.28 436.8 103.83 437.06 103.25 436.73",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.8,379.89a10.7,10.7,0,0,0-6-1.53h-.09a7.33,7.33,0,0,0-3,1,7.13,7.13,0,0,0-1.23.89,9.68,9.68,0,0,0-2.32,3.25,14.87,14.87,0,0,0-1.11,3.89,21.65,21.65,0,0,0-.2,2.74,26.18,26.18,0,0,0,.55,5.37l.07,0,.22-.06.39-.13.4-.2a1.27,1.27,0,0,0,.27-.18,1.66,1.66,0,0,0,.54-.63,23.35,23.35,0,0,1-.35-4.13,18.12,18.12,0,0,1,.27-3.05,10.66,10.66,0,0,1,1.52-4,6.11,6.11,0,0,1,2-1.94,5.23,5.23,0,0,1,1.72-.63l.36-.05a8.43,8.43,0,0,1,5,1.25c6.49,3.65,11.72,13.64,11.65,22.26,0,.1,0,.2,0,.3a18.15,18.15,0,0,1-.23,2.54,11.5,11.5,0,0,1-1.29,3.79l1.85.92a13.62,13.62,0,0,0,1.53-4.65,18.12,18.12,0,0,0,.22-2.61,2.44,2.44,0,0,0,0-.27C132.59,394.69,126.89,383.88,119.8,379.89Zm-8.35,23.61-.1.84a3.55,3.55,0,0,1-.78,1.73,27.4,27.4,0,0,0,4.22,5.3l1.83-1.12A25.38,25.38,0,0,1,111.45,403.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M119.8,379.89a10.7,10.7,0,0,0-6-1.53h-.09a7.33,7.33,0,0,0-3,1,7.13,7.13,0,0,0-1.23.89,9.68,9.68,0,0,0-2.32,3.25,14.87,14.87,0,0,0-1.11,3.89,21.65,21.65,0,0,0-.2,2.74,26.18,26.18,0,0,0,.55,5.37l.07,0,.22-.06.39-.13.4-.2a1.27,1.27,0,0,0,.27-.18,1.66,1.66,0,0,0,.54-.63,23.35,23.35,0,0,1-.35-4.13,18.12,18.12,0,0,1,.27-3.05,10.66,10.66,0,0,1,1.52-4,6.11,6.11,0,0,1,2-1.94,5.23,5.23,0,0,1,1.72-.63l.36-.05a8.43,8.43,0,0,1,5,1.25c6.49,3.65,11.72,13.64,11.65,22.26,0,.1,0,.2,0,.3a18.15,18.15,0,0,1-.23,2.54,11.5,11.5,0,0,1-1.29,3.79l1.85.92a13.62,13.62,0,0,0,1.53-4.65,18.12,18.12,0,0,0,.22-2.61,2.44,2.44,0,0,0,0-.27C132.59,394.69,126.89,383.88,119.8,379.89Zm-8.35,23.61-.1.84a3.55,3.55,0,0,1-.78,1.73,27.4,27.4,0,0,0,4.22,5.3l1.83-1.12A25.38,25.38,0,0,1,111.45,403.5Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cones--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cone--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.85,447.42l14.82-8.56a2.18,2.18,0,0,1,2,0l14.82,8.56a.68.68,0,0,1,.41.57v1.08a.69.69,0,0,1-.41.58l-14.82,8.55a2.18,2.18,0,0,1-2,0l-14.82-8.55a.69.69,0,0,1-.41-.58V448A.68.68,0,0,1,353.85,447.42Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.44,448v1.08a.69.69,0,0,0,.41.58l14.82,8.55a2,2,0,0,0,1,.24V438.62a2,2,0,0,0-1,.24l-14.82,8.56A.68.68,0,0,0,353.44,448Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.66,438.62v19.82a2,2,0,0,0,1-.24l14.82-8.55a.69.69,0,0,0,.41-.58V448a.68.68,0,0,0-.41-.57l-14.82-8.56A2,2,0,0,0,369.66,438.62Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.66,457.12l14.82-8.55a.61.61,0,0,0,0-1.15l-14.82-8.56a2.18,2.18,0,0,0-2,0l-14.82,8.56a.61.61,0,0,0,0,1.15l14.82,8.55A2.18,2.18,0,0,0,370.66,457.12Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.66,457.12l14.82-8.55a.61.61,0,0,0,0-1.15l-14.82-8.56a2.18,2.18,0,0,0-2,0l-14.82,8.56a.61.61,0,0,0,0,1.15l14.82,8.55A2.18,2.18,0,0,0,370.66,457.12Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.66,438.62a2,2,0,0,1,1,.24l14.82,8.56a.61.61,0,0,1,0,1.15l-14.82,8.55a2,2,0,0,1-1,.24Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.52,446.91h0l6.56-19.7h0v0h0a1.57,1.57,0,0,1,.72-.76,4.09,4.09,0,0,1,3.73,0,1.57,1.57,0,0,1,.72.76h0v0h0l6.56,19.7h0c.61,1.72-.24,3.57-2.54,4.9a14.64,14.64,0,0,1-13.21,0C360.76,450.48,359.91,448.63,360.52,446.91Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.52,446.91h0l6.56-19.7h0v0h0a1.57,1.57,0,0,1,.72-.76,4.09,4.09,0,0,1,3.73,0,1.57,1.57,0,0,1,.72.76h0v0h0l6.56,19.7h0c.61,1.72-.24,3.57-2.54,4.9a14.64,14.64,0,0,1-13.21,0C360.76,450.48,359.91,448.63,360.52,446.91Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.19,432.86v0l.93-2.8a1.34,1.34,0,0,0,.41,1.41,2.54,2.54,0,0,0,.58.45,5.63,5.63,0,0,0,5.09,0,2.78,2.78,0,0,0,.58-.45,1.35,1.35,0,0,0,.41-1.41l.93,2.8v0a1.63,1.63,0,0,1-.21,1.41,2.92,2.92,0,0,1-1,.94,5.17,5.17,0,0,1-1.13.47,7.65,7.65,0,0,1-4.19,0,5.17,5.17,0,0,1-1.13-.47,2.92,2.92,0,0,1-1-.94A1.63,1.63,0,0,1,365.19,432.86Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.43,444.15v0l.93-2.8a2.51,2.51,0,0,0-.05,1.41,3.18,3.18,0,0,0,.79,1.41,5.55,5.55,0,0,0,1.3,1,11.65,11.65,0,0,0,10.51,0,5.55,5.55,0,0,0,1.3-1,3.18,3.18,0,0,0,.79-1.41,2.6,2.6,0,0,0-.05-1.41l.93,2.8v0a2.83,2.83,0,0,1,.1,1.41,4.48,4.48,0,0,1-2.41,2.93,13.09,13.09,0,0,1-11.85,0,4.48,4.48,0,0,1-2.41-2.93A2.83,2.83,0,0,1,361.43,444.15Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.31,438.51v0l.93-2.81a1.92,1.92,0,0,0,.09,1.41,3.27,3.27,0,0,0,1.38,1.42l0,0a8.56,8.56,0,0,0,7.79,0l.05,0a3.27,3.27,0,0,0,1.38-1.42,1.92,1.92,0,0,0,.09-1.41l.93,2.81v0a2.27,2.27,0,0,1,0,1.41,3.19,3.19,0,0,1-1,1.41,5.49,5.49,0,0,1-.75.52,8.09,8.09,0,0,1-2.49.89,10.84,10.84,0,0,1-4.17,0,8.09,8.09,0,0,1-2.49-.89,5.49,5.49,0,0,1-.75-.52,3.19,3.19,0,0,1-1-1.41A2.27,2.27,0,0,1,363.31,438.51Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.66,426a3.78,3.78,0,0,1,1.87.45,1.57,1.57,0,0,1,.72.76h0v0h0l6.56,19.7h0c.61,1.72-.24,3.57-2.54,4.9a13.52,13.52,0,0,1-6.61,1.58h.06a5.55,5.55,0,0,0,4.54-6.27l-2.73-19.61Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.53,428.58a1.14,1.14,0,0,0,0-2.16,4.09,4.09,0,0,0-3.73,0,1.14,1.14,0,0,0,0,2.16A4.15,4.15,0,0,0,371.53,428.58Z",
    style: {
      fill: "#BA68C8"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--cone--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.69,441.44l14.82-8.56a2.2,2.2,0,0,1,2,0l14.81,8.56a.69.69,0,0,1,.41.57v1.08a.69.69,0,0,1-.41.58l-14.81,8.55a2.2,2.2,0,0,1-2,0l-14.82-8.55a.71.71,0,0,1-.41-.58V442A.71.71,0,0,1,394.69,441.44Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.28,442v1.08a.71.71,0,0,0,.41.58l14.82,8.55a2.05,2.05,0,0,0,1,.24V432.64a2.05,2.05,0,0,0-1,.24l-14.82,8.56A.71.71,0,0,0,394.28,442Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.51,432.64v19.82a2.05,2.05,0,0,0,1-.24l14.81-8.55a.69.69,0,0,0,.41-.58V442a.69.69,0,0,0-.41-.57l-14.81-8.56A2.05,2.05,0,0,0,410.51,432.64Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.5,451.15l14.83-8.56a.61.61,0,0,0,0-1.15l-14.83-8.56a2.18,2.18,0,0,0-2,0l-14.82,8.56a.61.61,0,0,0,0,1.15l14.82,8.56A2.25,2.25,0,0,0,411.5,451.15Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.5,451.15l14.83-8.56a.61.61,0,0,0,0-1.15l-14.83-8.56a2.18,2.18,0,0,0-2,0l-14.82,8.56a.61.61,0,0,0,0,1.15l14.82,8.56A2.25,2.25,0,0,0,411.5,451.15Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.51,432.64a2,2,0,0,1,1,.24l14.83,8.56a.61.61,0,0,1,0,1.15l-14.83,8.56a2.1,2.1,0,0,1-1,.23Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.36,440.93h0l6.55-19.7h0v0h0a1.5,1.5,0,0,1,.71-.76,4.11,4.11,0,0,1,3.74,0,1.54,1.54,0,0,1,.71.76h0v0h0l6.56,19.7h0c.6,1.72-.24,3.57-2.55,4.9a14.64,14.64,0,0,1-13.21,0C401.6,444.5,400.76,442.65,401.36,440.93Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.36,440.93h0l6.55-19.7h0v0h0a1.5,1.5,0,0,1,.71-.76,4.11,4.11,0,0,1,3.74,0,1.54,1.54,0,0,1,.71.76h0v0h0l6.56,19.7h0c.6,1.72-.24,3.57-2.55,4.9a14.64,14.64,0,0,1-13.21,0C401.6,444.5,400.76,442.65,401.36,440.93Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406,426.88v0l.93-2.8a1.38,1.38,0,0,0,.41,1.41,3.06,3.06,0,0,0,.58.45,5.63,5.63,0,0,0,5.09,0,2.85,2.85,0,0,0,.59-.45,1.36,1.36,0,0,0,.4-1.41l.94,2.8v0a1.59,1.59,0,0,1-.2,1.41,3,3,0,0,1-1,.94,5.17,5.17,0,0,1-1.13.47,7.61,7.61,0,0,1-4.18,0,5,5,0,0,1-1.13-.47,3,3,0,0,1-1.05-.94A1.63,1.63,0,0,1,406,426.88Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.28,438.17v0l.94-2.8a2.51,2.51,0,0,0-.06,1.41,3.18,3.18,0,0,0,.79,1.41,5.41,5.41,0,0,0,1.31,1,11.63,11.63,0,0,0,10.5,0,5.35,5.35,0,0,0,1.3-1,3,3,0,0,0,.79-1.41,2.42,2.42,0,0,0-.05-1.41l.93,2.8v0a2.83,2.83,0,0,1,.11,1.41,4.54,4.54,0,0,1-2.41,2.93,13.11,13.11,0,0,1-11.86,0,4.48,4.48,0,0,1-2.41-2.93A2.83,2.83,0,0,1,402.28,438.17Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.15,432.53v0l.93-2.81a1.92,1.92,0,0,0,.09,1.41,3.35,3.35,0,0,0,1.39,1.42l0,0a8.58,8.58,0,0,0,7.8,0l0,0a3.27,3.27,0,0,0,1.38-1.42,1.87,1.87,0,0,0,.09-1.41l.94,2.81v0a2.13,2.13,0,0,1,0,1.41,3.19,3.19,0,0,1-1,1.41,4.93,4.93,0,0,1-.75.52,8,8,0,0,1-2.48.89,10.89,10.89,0,0,1-4.18,0,8.18,8.18,0,0,1-2.49-.89,5.49,5.49,0,0,1-.75-.52,3.16,3.16,0,0,1-1-1.41A2.2,2.2,0,0,1,404.15,432.53Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.51,420a3.83,3.83,0,0,1,1.87.45,1.54,1.54,0,0,1,.71.76h0v0h0l6.56,19.7h0c.6,1.72-.24,3.57-2.55,4.9a13.51,13.51,0,0,1-6.6,1.58h.05a5.55,5.55,0,0,0,4.54-6.27l-2.72-19.61Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.38,422.6a1.14,1.14,0,0,0,0-2.16,4.11,4.11,0,0,0-3.74,0,1.14,1.14,0,0,0,0,2.16A4.17,4.17,0,0,0,412.38,422.6Z",
    style: {
      fill: "#BA68C8"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--cone--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.28,448.86l14.82-8.56a2.05,2.05,0,0,1,1-.24,2,2,0,0,1,1,.24l14.82,8.56a.69.69,0,0,1,.41.57v1.08a.69.69,0,0,1-.41.58l-14.82,8.55a2,2,0,0,1-1,.24,2.05,2.05,0,0,1-1-.24l-14.82-8.55a.69.69,0,0,1-.41-.58v-1.08A.69.69,0,0,1,169.28,448.86Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.87,449.43v1.08a.69.69,0,0,0,.41.58l14.82,8.55a2.05,2.05,0,0,0,1,.24V440.06a2.05,2.05,0,0,0-1,.24l-14.82,8.56A.69.69,0,0,0,168.87,449.43Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.1,440.06v19.82a2,2,0,0,0,1-.24l14.82-8.55a.69.69,0,0,0,.41-.58v-1.08a.69.69,0,0,0-.41-.57l-14.82-8.56A2,2,0,0,0,185.1,440.06Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.09,458.57,200.92,450a.61.61,0,0,0,0-1.15l-14.83-8.56a2.18,2.18,0,0,0-2,0l-14.82,8.56a.61.61,0,0,0,0,1.15l14.82,8.56A2.25,2.25,0,0,0,186.09,458.57Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.09,458.57,200.92,450a.61.61,0,0,0,0-1.15l-14.83-8.56a2.18,2.18,0,0,0-2,0l-14.82,8.56a.61.61,0,0,0,0,1.15l14.82,8.56A2.25,2.25,0,0,0,186.09,458.57Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.1,440.06a2,2,0,0,1,1,.24l14.83,8.56a.61.61,0,0,1,0,1.15l-14.83,8.56a2,2,0,0,1-1,.23Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,448.36h0l6.56-19.71h0v0h0a1.54,1.54,0,0,1,.71-.76,4.17,4.17,0,0,1,3.74,0,1.58,1.58,0,0,1,.71.76h0v0h0l6.56,19.71h0c.6,1.71-.25,3.56-2.55,4.89a14.64,14.64,0,0,1-13.21,0C176.19,451.92,175.34,450.07,176,448.36Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,448.36h0l6.56-19.71h0v0h0a1.54,1.54,0,0,1,.71-.76,4.17,4.17,0,0,1,3.74,0,1.58,1.58,0,0,1,.71.76h0v0h0l6.56,19.71h0c.6,1.71-.25,3.56-2.55,4.89a14.64,14.64,0,0,1-13.21,0C176.19,451.92,175.34,450.07,176,448.36Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.62,434.3v0l.93-2.8a1.36,1.36,0,0,0,.41,1.41,2.78,2.78,0,0,0,.58.45,5.63,5.63,0,0,0,5.09,0,2.85,2.85,0,0,0,.59-.45,1.36,1.36,0,0,0,.4-1.41l.94,2.81h0a1.59,1.59,0,0,1-.2,1.41,3.17,3.17,0,0,1-1.05,1,5.69,5.69,0,0,1-1.13.46,7.61,7.61,0,0,1-4.18,0,5.24,5.24,0,0,1-1.13-.46,3.07,3.07,0,0,1-1-1A1.63,1.63,0,0,1,180.62,434.3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.86,445.59v0l.93-2.8a2.6,2.6,0,0,0-.05,1.41,3.18,3.18,0,0,0,.79,1.41,5.41,5.41,0,0,0,1.31,1,11.57,11.57,0,0,0,10.5,0,5.35,5.35,0,0,0,1.3-1,3.18,3.18,0,0,0,.79-1.41,2.51,2.51,0,0,0-.05-1.41l.93,2.8v0a2.82,2.82,0,0,1,.1,1.41,4.5,4.5,0,0,1-2.4,2.92,13.11,13.11,0,0,1-11.86,0,4.49,4.49,0,0,1-2.41-2.92A3,3,0,0,1,176.86,445.59Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.74,440v0l.93-2.8a1.89,1.89,0,0,0,.09,1.4,3.35,3.35,0,0,0,1.39,1.42l0,0a8.58,8.58,0,0,0,7.8,0l0,0a3.27,3.27,0,0,0,1.38-1.42,1.87,1.87,0,0,0,.09-1.41l.93,2.81v0a2.13,2.13,0,0,1,0,1.41,3.19,3.19,0,0,1-1,1.41,4.93,4.93,0,0,1-.75.52,8.12,8.12,0,0,1-2.48.89,10.89,10.89,0,0,1-4.18,0,8.18,8.18,0,0,1-2.49-.89,5.49,5.49,0,0,1-.75-.52,3.16,3.16,0,0,1-1-1.41A2.2,2.2,0,0,1,178.74,440Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.1,427.41a3.83,3.83,0,0,1,1.87.45,1.58,1.58,0,0,1,.71.76h0v0h0l6.56,19.71h0c.6,1.71-.25,3.56-2.55,4.89a13.51,13.51,0,0,1-6.6,1.58h.05a5.55,5.55,0,0,0,4.54-6.27L187,428.94Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187,430a1.14,1.14,0,0,0,0-2.16,4.17,4.17,0,0,0-3.74,0,1.14,1.14,0,0,0,0,2.16A4.17,4.17,0,0,0,187,430Z",
    style: {
      fill: "#BA68C8"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Barrier--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--barrier--inject-64"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "433.21 402.86 455.2 390.16 474.05 401.05 452.06 413.74 433.21 402.86",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "433.21 402.86 433.21 406.49 452.06 417.37 452.06 413.74 433.21 402.86",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "474.05 401.05 474.04 404.67 452.06 417.37 452.06 413.74 474.05 401.05",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.22,327.83a2.36,2.36,0,0,0-2.37.23l-9,5.2a7.41,7.41,0,0,0-3.35,5.8v63.8l12.57,7.25,15.7-9.07V337.25a2.36,2.36,0,0,0-1-2.16Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453,343a6.79,6.79,0,0,0-1,3.3v63.79l-12.57-7.25v-63.8a6.73,6.73,0,0,1,1-3.3Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.06,346.32a7.41,7.41,0,0,1,3.34-5.8l9-5.2c1.85-1.07,3.35-.2,3.35,1.93V401l-15.7,9.07Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.74,335.06a2.36,2.36,0,0,0-2.32.26l-9,5.2A6.78,6.78,0,0,0,453,343l-12.56-7.25a6.86,6.86,0,0,1,2.36-2.5l9-5.19a2.34,2.34,0,0,1,2.37-.24Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "455.2 347.89 464.62 342.45 464.62 349.71 455.2 355.15 455.2 347.89",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "463.71 349.18 464.62 349.71 464.62 342.45 463.71 342.98 463.71 349.18",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "463.71 349.18 463.71 342.98 455.2 347.89 455.2 354.09 463.71 349.18",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "463.71 349.18 463.71 342.98 455.2 347.89 455.2 354.09 463.71 349.18",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.2,359.16a.39.39,0,0,1-.34-.19.4.4,0,0,1,.14-.53l9.43-5.44a.38.38,0,0,1,.53.14.39.39,0,0,1-.15.53l-9.42,5.44A.45.45,0,0,1,455.2,359.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.2,362.79a.38.38,0,0,1-.34-.2.39.39,0,0,1,.14-.52l9.43-5.45a.39.39,0,0,1,.38.68l-9.42,5.44A.45.45,0,0,1,455.2,362.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.2,366.41a.37.37,0,0,1-.34-.19.4.4,0,0,1,.14-.53l9.43-5.44a.4.4,0,0,1,.53.14.39.39,0,0,1-.15.53l-9.42,5.44A.34.34,0,0,1,455.2,366.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.66 430.42 434.46 362.42 434.46 352.61 316.66 420.62 316.66 430.42",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.52 418.8 313.52 428.61 316.66 430.42 316.66 420.62 313.52 418.8",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.52 418.8 313.52 428.61 316.66 430.42 316.66 420.62 313.52 418.8",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "434.46 352.61 431.32 350.8 313.52 418.8 316.66 420.62 434.46 352.61",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.66 410.64 330.8 412.46 340.22 407.02 337.08 405.2 327.66 410.64",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.66 420.62 321.37 417.9 318.23 416.08 313.52 418.8 316.66 420.62",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.5 399.76 349.64 401.57 359.07 396.13 355.93 394.32 346.5 399.76",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.35 388.88 368.49 390.69 377.92 385.25 374.77 383.44 365.35 388.88",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "384.2 378 387.34 379.81 396.76 374.37 393.62 372.56 384.2 378",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.05 367.12 406.19 368.93 415.61 363.49 412.47 361.68 403.05 367.12",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "421.89 356.24 425.03 358.05 434.46 352.61 431.32 350.8 421.89 356.24",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "327.66 410.64 330.8 412.46 340.22 407.02 337.08 405.2 327.66 410.64",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.66 420.62 321.37 417.9 318.23 416.08 313.52 418.8 316.66 420.62",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.5 399.76 349.64 401.57 359.07 396.13 355.93 394.32 346.5 399.76",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.35 388.88 368.49 390.69 377.92 385.25 374.77 383.44 365.35 388.88",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "384.2 378 387.34 379.81 396.76 374.37 393.62 372.56 384.2 378",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.05 367.12 406.19 368.93 415.61 363.49 412.47 361.68 403.05 367.12",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "421.89 356.24 425.03 358.05 434.46 352.61 431.32 350.8 421.89 356.24",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "396.76 374.37 388.48 379.15 387.34 379.81 381.06 393.25 390.48 387.81 396.76 374.37",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.07 396.13 349.64 401.57 343.37 415.01 352.79 409.57 359.07 396.13",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.94 420.45 340.22 407.02 332.54 411.45 330.8 412.46 324.52 425.89 333.94 420.45",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.92 385.25 368.75 390.55 368.49 390.69 362.21 404.13 371.64 398.69 377.92 385.25",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.33 376.93 415.61 363.49 408.6 367.54 406.19 368.93 399.91 382.37 409.33 376.93",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.37 417.9 316.66 420.62 316.66 426.35 321.37 417.9",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "432.9 353.51 425.03 358.05 418.75 371.49 428.18 366.05 434.46 352.61 432.9 353.51",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "434.46 359.87 447.84 352.13 447.84 344.88 434.46 352.61 434.46 359.87",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "447.84 344.88 444.7 343.06 431.32 350.8 434.46 352.61 447.84 344.88",
    style: {
      fill: "#455a64"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroParking);
export default __webpack_public_path__ + "static/media/hero_parking.a74d3fa1a684dd3e69f8d7fe602b192f.svg";
export { ForwardRef as ReactComponent };